export default {
    zh: {
        // 页面标题和描述
        pageTitle: 'Google Veo 3.1 视频生成器 - 免费体验最新AI视频创作工具',
        pageDescription:
            '体验Google Veo 3.1 视频生成器，支持连帧成片、素材生视频、原生音频生成等核心功能。在WeryAI平台免费试用，创造专业级AI视频内容。',
        pageKeywords:
            'Veo 3.1, Google AI视频生成器, AI视频创作, 人工智能视频, 视频生成工具, 免费AI视频, 微鲤AI, 视频制作',

        // 生成器部分
        generatorTitle: 'Google Veo 3.1 视频生成器',
        generatorDescription:
            'Google Veo 3.1 是一款最先进的 AI 视频模型，能够生成高质量、逼真自然的音频视频。它是 Veo 3 的升级版本，在质量和功能上都有显著提升。快来 微鲤AI 视频生成器免费体验 Veo 3.1 ！',

        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Veo 3.1 核心功能特性',
        coreFeaturesSubtitle:
            '深入了解 Google Veo 3.1 视频生成器的核心功能，体验下一代AI视频创作技术',

        // 连帧成片功能
        frameToVideoTitle: '连帧成片（首尾帧控制）',
        frameToVideoDescription:
            'Veo 3.1 支持通过首尾帧控制视频生成，让您精确掌控视频的起始和结束画面，创造更具连贯性的视觉叙事。',
        frameToFrameTitle: '帧间控制',
        frameToFrameDescription:
            '通过指定首尾帧来控制视频生成，创建流畅的过渡和连贯的视觉叙事。',

        // 素材生视频功能
        materialToVideoTitle: '素材生视频',
        materialToVideoDescription:
            '基于现有素材和参考材料创建高质量视频，实现素材的智能化二次创作和视觉升级。',

        // 原生音频生成功能
        nativeAudioTitle: '原生音频生成',
        nativeAudioDescription:
            'Veo 3.1 创建音频并将其集成到生成的视频中，实现完美的视听同步体验，让您的视频更具吸引力和真实感。',

        // 一致角色功能
        consistentCharacterTitle: '一致的角色表现',
        consistentCharacterDescription:
            '确保角色在不同场景和镜头中保持高度一致的外观和特征，创造连贯的视觉体验。',

        // 高级提示理解功能
        advancedPromptTitle: '高级提示词理解',
        advancedPromptDescription:
            '高精度地解读复杂提示词，准确理解您的创意意图，将文字描述转化为生动的视觉画面。',

        // 场景扩展功能
        sceneExpansionTitle: '强大的场景扩展',
        sceneExpansionDescription:
            '智能扩展视频场景，生成更丰富的视觉内容，让您的创意突破时间和空间的限制。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',
        step1Title: '选择模型',
        step1Description: '在 AI 视频工具中选择 Veo 3.1 模型',
        step2Title: '输入内容',
        step2Description: '输入提示词或上传参考图像',
        step3Title: '生成视频',
        step3Description: '点击生成按钮，等待并下载您的视频',

        // YouTube 视频部分
        youtubeVideosTitle: 'Google Veo 3.1 视频模型相关 YouTube 视频',
        youtubeVideoTitle: 'Google Veo 3.1 视频模型相关 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Veo 3.1 AI 视频模型的 X 推文',

        // 探索其他模型部分
        exploreOtherModelsTitle: '探索其他 Veo 模型',
        veo2Title: 'Google Veo 2 AI视频生成器',
        veo3Title: 'Google Veo 3 AI视频生成器',
        veo3FastTitle: 'Google Veo 3 Fast AI视频生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',
        faq1Question: '什么是 Google Veo 3.1？',
        faq1Answer:
            'Google Veo 3.1 是 Google DeepMind 开发的最新一代AI视频生成模型，是Veo 3的升级版本。它能够根据文本提示或参考图像生成高质量、逼真的视频内容，支持连帧成片、素材生视频、原生音频生成等先进功能。',
        faq2Question: 'Veo 3.1 与 Veo 3 有什么区别？',
        faq2Answer:
            'Veo 3.1 是 Veo 3 的增强版本，主要改进包括：更强的连帧成片能力、更好的素材生视频效果、更智能的场景扩展功能、更精准的提示词理解、以及更高的视频生成质量。Veo 3.1 在保持 Veo 3 核心优势的基础上，进一步提升了创作灵活性和输出质量。',
        faq3Question: 'Veo 3.1 可以生成多长的视频？',
        faq3Answer:
            'Veo 3.1 支持生成不同时长的视频，具体时长取决于您选择的配置和平台限制。在 微鲤AI 平台上，您可以根据需求生成从几秒到数分钟不等的视频内容。',
        faq4Question: '如何在 微鲤AI 上使用 Veo 3.1？',
        faq4Answer:
            '使用非常简单：1) 访问 微鲤AI 平台并选择 Veo 3.1 模型；2) 输入您的文本提示或上传参考图像；3) 点击生成按钮，等待AI创作完成；4) 下载或分享您的视频。',
        faq5Question: 'Veo 3.1 生成的视频是否包含水印？',
        faq5Answer:
            '这取决于您的 微鲤AI 订阅计划。免费用户生成的视频可能包含水印，而付费订阅用户则可以获得无水印的高质量视频输出。',
        faq6Question: 'Veo 3.1 支持哪些语言的提示词？',
        faq6Answer:
            'Veo 3.1 支持多种语言的提示词输入，包括中文、英文、日文、韩文等主流语言。AI模型能够准确理解不同语言的创意描述并生成相应的视频内容。',
        faq7Question: '我可以商用 Veo 3.1 生成的视频吗？',
        faq7Answer:
            '视频的商业使用权利取决于 微鲤AI 的服务条款和您的订阅计划。建议在商业使用前查看平台的使用协议，或联系客服了解详细的授权信息。',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaSubtitle: '立即体验 Veo 3.1，将您的创意转化为精彩视频',
        ctaDescription:
            '体验 Veo 3.1 的强大功能，将您的创意想法转化为专业视频内容',
        ctaButton: '开始创作',
        ctaNote: '无需信用卡 · 新用户免费体验',

        // 视频播放相关
        videoNotSupported: '您的浏览器不支持视频播放',
        videoUnsupported: '您的浏览器不支持视频播放',
        videoLoadError: '视频加载失败',
        videoReload: '重新加载',
    },
    en: {
        // Page title and description
        pageTitle:
            'Google Veo 3.1 | Advanced AI Video Generation Model | 微鲤AI',
        pageDescription:
            'Google Veo 3.1 generates high-quality, realistic videos with frame control, material-to-video, native audio, scene expansion, and precise prompt understanding. Try it free on 微鲤AI.',
        pageKeywords:
            'Veo 3.1, Google Veo, AI video generator, advanced video model, text to video, AI video creation, 微鲤AI Veo 3.1',

        // Generator section
        generatorTitle: 'Google Veo 3.1 AI Video Generator',
        generatorDescription:
            "Google Veo 3.1 is the most advanced AI video model that generates high-quality, realistic audio-visual content. It's an upgraded version of Veo 3 with significant improvements in quality and features. Try Veo 3.1 for free on 微鲤AI video generator!",

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Veo 3.1 Core Features',
        coreFeaturesSubtitle:
            'Explore the core capabilities of Google Veo 3.1 AI video generator and experience next-generation AI video creation',

        // Frame to video feature
        frameToVideoTitle: 'Frame-to-Video (First & Last Frame Control)',
        frameToVideoDescription:
            'Veo 3.1 supports video generation through first and last frame control, allowing you to precisely control the start and end frames of your video for more coherent visual storytelling.',
        frameToFrameTitle: 'Frame-to-Frame Control',
        frameToFrameDescription:
            'Control video generation by specifying the first and last frame, creating smooth transitions and coherent visual narratives.',

        // Material to video feature
        materialToVideoTitle: 'Material to Video',
        materialToVideoDescription:
            'Create high-quality videos based on existing materials and references, enabling intelligent recreation and visual enhancement of your content.',

        // Native audio generation feature
        nativeAudioTitle: 'Native Audio Generation',
        nativeAudioDescription:
            'Veo 3.1 creates audio and integrates it into generated videos, achieving perfect audio-visual synchronization for more engaging and realistic content.',

        // Consistent character feature
        consistentCharacterTitle: 'Consistent Character Performance',
        consistentCharacterDescription:
            'Ensure characters maintain highly consistent appearance and characteristics across different scenes and shots, creating a coherent visual experience.',

        // Advanced prompt feature
        advancedPromptTitle: 'Advanced Prompt Understanding',
        advancedPromptDescription:
            'Precisely interpret complex prompts, accurately understand your creative intent, and transform text descriptions into vivid visual scenes.',

        // Scene expansion feature
        sceneExpansionTitle: 'Powerful Scene Expansion',
        sceneExpansionDescription:
            'Intelligently expand video scenes to generate richer visual content, letting your creativity break through time and space limitations.',

        // How to use section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Start Creating in Three Simple Steps',
        step1Title: 'Select Model',
        step1Description: 'Choose Veo 3.1 model in AI video tools',
        step2Title: 'Input Content',
        step2Description: 'Enter text prompt or upload reference image',
        step3Title: 'Generate Video',
        step3Description: 'Click generate button, wait and download your video',

        // YouTube videos section
        youtubeVideosTitle:
            'YouTube Videos about Google Veo 3.1 AI Video Model',
        youtubeVideoTitle: 'YouTube Videos about Google Veo 3.1 AI Video Model',

        // X Posts section
        xPostsTitle: 'X Posts about Veo 3.1 AI Video Model',

        // Explore other models section
        exploreOtherModelsTitle: 'Explore Other Veo Models',
        veo2Title: 'Google Veo 2 AI Video Generator',
        veo3Title: 'Google Veo 3 AI Video Generator',
        veo3FastTitle: 'Google Veo 3 Fast AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is Google Veo 3.1?',
        faq1Answer:
            'Google Veo 3.1 is the latest AI video generation model developed by Google DeepMind, an upgraded version of Veo 3. It can generate high-quality, realistic video content based on text prompts or reference images, supporting advanced features like frame-to-video, material-to-video, and native audio generation.',
        faq2Question: "What's the difference between Veo 3.1 and Veo 3?",
        faq2Answer:
            "Veo 3.1 is an enhanced version of Veo 3, with key improvements including: stronger frame-to-video capabilities, better material-to-video effects, smarter scene expansion, more precise prompt understanding, and higher video generation quality. Veo 3.1 further enhances creative flexibility and output quality while maintaining Veo 3's core advantages.",
        faq3Question: 'How long can Veo 3.1 generate videos?',
        faq3Answer:
            'Veo 3.1 supports generating videos of various lengths, depending on your chosen configuration and platform limitations. On the 微鲤AI platform, you can generate videos ranging from a few seconds to several minutes.',
        faq4Question: 'How do I use Veo 3.1 on 微鲤AI?',
        faq4Answer:
            "It's very simple: 1) Visit 微鲤AI platform and select Veo 3.1 model; 2) Enter your text prompt or upload reference image; 3) Click generate button and wait for AI creation; 4) Download or share your video.",
        faq5Question: 'Do Veo 3.1 generated videos contain watermarks?',
        faq5Answer:
            'This depends on your 微鲤AI subscription plan. Videos generated by free users may contain watermarks, while paid subscribers can get high-quality videos without watermarks.',
        faq6Question: 'What languages does Veo 3.1 support for prompts?',
        faq6Answer:
            'Veo 3.1 supports prompts in multiple languages, including Chinese, English, Japanese, Korean, and other mainstream languages. The AI model can accurately understand creative descriptions in different languages and generate corresponding video content.',
        faq7Question: 'Can I use Veo 3.1 generated videos commercially?',
        faq7Answer:
            "Commercial use rights depend on 微鲤AI\'s terms of service and your subscription plan. We recommend checking the platform's usage agreement before commercial use, or contacting customer service for detailed licensing information.",

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaSubtitle: 'Try Veo 3.1 now and transform your ideas into stunning videos',
        ctaDescription:
            'Experience the power of Veo 3.1 and turn your creative ideas into professional video content.',
        ctaButton: 'Start Creating',
        ctaNote: 'No credit card required · Free trial for new users',

        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoUnsupported: 'Your browser does not support video playback',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
    },
    ja: {
        // ページタイトルと説明
        pageTitle:
            'Google Veo 3.1 AI動画ジェネレーター - 無料で最新のAI動画作成ツールを体験',
        pageDescription:
            'Google Veo 3.1 AI動画ジェネレーターを体験。フレーム連結、素材から動画、ネイティブオーディオ生成などのコア機能をサポート。WeryAIプラットフォームで無料でお試しいただき、プロフェッショナルなAI動画コンテンツを作成できます。',
        pageKeywords:
            'Veo 3.1, Google AI動画ジェネレーター, AI動画作成, 人工知能動画, 動画生成ツール, 無料AI動画, 微鲤AI, 動画制作',

        // ジェネレーターセクション
        generatorTitle: 'Google Veo 3.1 AI動画ジェネレーター',
        generatorDescription:
            'Google Veo 3.1は、高品質でリアルなオーディオビジュアルコンテンツを生成する最先端のAI動画モデルです。Veo 3のアップグレード版で、品質と機能が大幅に向上しています。WeryAI動画ジェネレーターでVeo 3.1を無料でお試しください！',

        // タブ
        tabImageToVideo: '画像から動画',
        tabTextToVideo: 'テキストから動画',

        // コア機能セクション
        coreFeaturesTitle: 'Veo 3.1のコア機能',
        coreFeaturesSubtitle:
            'Google Veo 3.1 AI動画ジェネレーターのコア機能を探索し、次世代のAI動画作成を体験',

        // フレーム連結機能
        frameToVideoTitle: 'フレーム連結（最初と最後のフレーム制御）',
        frameToVideoDescription:
            'Veo 3.1は最初と最後のフレーム制御による動画生成をサポートし、動画の開始と終了フレームを正確に制御して、より一貫性のあるビジュアルストーリーテリングを実現します。',
        frameToFrameTitle: 'フレーム間制御',
        frameToFrameDescription:
            '最初と最後のフレームを指定して動画生成を制御し、滑らかなトランジションと一貫性のあるビジュアルナラティブを作成します。',

        // 素材から動画機能
        materialToVideoTitle: '素材から動画',
        materialToVideoDescription:
            '既存の素材や参考資料に基づいて高品質な動画を作成し、コンテンツのインテリジェントな再創作とビジュアルアップグレードを実現します。',

        // ネイティブオーディオ生成機能
        nativeAudioTitle: 'ネイティブオーディオ生成',
        nativeAudioDescription:
            'Veo 3.1はオーディオを作成し、生成された動画に統合することで、完璧な音声と映像の同期を実現し、より魅力的でリアルなコンテンツを提供します。',

        // 一貫したキャラクター機能
        consistentCharacterTitle: '一貫したキャラクターパフォーマンス',
        consistentCharacterDescription:
            'キャラクターが異なるシーンやショットで高度に一貫した外観と特徴を維持し、一貫性のある視覚体験を創出します。',

        // 高度なプロンプト機能
        advancedPromptTitle: '高度なプロンプト理解',
        advancedPromptDescription:
            '複雑なプロンプトを正確に解釈し、クリエイティブな意図を正確に理解して、テキストの説明を生き生きとした視覚シーンに変換します。',

        // シーン拡張機能
        sceneExpansionTitle: '強力なシーン拡張',
        sceneExpansionDescription:
            '動画シーンをインテリジェントに拡張してより豊かなビジュアルコンテンツを生成し、創造性が時間と空間の制限を突破できるようにします。',

        // 使い方セクション
        howToUseTitle: '使い方',
        howToUseSubtitle: '3つの簡単なステップで作成開始',
        step1Title: 'モデル選択',
        step1Description: 'AI動画ツールでVeo 3.1モデルを選択',
        step2Title: 'コンテンツ入力',
        step2Description:
            'テキストプロンプトを入力または参考画像をアップロード',
        step3Title: '動画生成',
        step3Description: '生成ボタンをクリックして、動画を待ってダウンロード',

        // YouTube動画セクション
        youtubeVideosTitle: 'Google Veo 3.1 AI動画モデルに関するYouTube動画',
        youtubeVideoTitle: 'Google Veo 3.1 AI動画モデルに関するYouTube動画',

        // X投稿セクション
        xPostsTitle: 'Veo 3.1 AI動画モデルに関するX投稿',

        // 他のモデルを探索セクション
        exploreOtherModelsTitle: '他のVeoモデルを探索',
        veo2Title: 'Google Veo 2 AI動画ジェネレーター',
        veo3Title: 'Google Veo 3 AI動画ジェネレーター',
        veo3FastTitle: 'Google Veo 3 Fast AI動画ジェネレーター',

        // FAQセクション
        faqTitle: 'よくある質問',
        faq1Question: 'Google Veo 3.1とは何ですか？',
        faq1Answer:
            'Google Veo 3.1は、Google DeepMindが開発した最新のAI動画生成モデルで、Veo 3のアップグレード版です。テキストプロンプトや参考画像に基づいて高品質でリアルな動画コンテンツを生成でき、フレーム連結、素材から動画、ネイティブオーディオ生成などの高度な機能をサポートしています。',
        faq2Question: 'Veo 3.1とVeo 3の違いは何ですか？',
        faq2Answer:
            'Veo 3.1はVeo 3の強化版で、主な改善点には：より強力なフレーム連結機能、より優れた素材から動画効果、よりスマートなシーン拡張、より正確なプロンプト理解、そしてより高い動画生成品質が含まれます。Veo 3.1は、Veo 3のコアの利点を維持しながら、創造的な柔軟性と出力品質をさらに向上させています。',
        faq3Question: 'Veo 3.1はどのくらいの長さの動画を生成できますか？',
        faq3Answer:
            'Veo 3.1は様々な長さの動画の生成をサポートしており、選択した構成とプラットフォームの制限に依存します。WeryAIプラットフォームでは、数秒から数分までの動画コンテンツを生成できます。',
        faq4Question: 'WeryAIでVeo 3.1を使用するにはどうすればよいですか？',
        faq4Answer:
            '非常に簡単です：1) WeryAIプラットフォームにアクセスしてVeo 3.1モデルを選択；2) テキストプロンプトを入力または参考画像をアップロード；3) 生成ボタンをクリックしてAI作成を待つ；4) 動画をダウンロードまたは共有。',
        faq5Question:
            'Veo 3.1で生成された動画にウォーターマークは含まれますか？',
        faq5Answer:
            'これはWeryAIのサブスクリプションプランに依存します。無料ユーザーが生成した動画にはウォーターマークが含まれる場合がありますが、有料サブスクライバーはウォーターマークのない高品質な動画を取得できます。',
        faq6Question: 'Veo 3.1はどの言語のプロンプトをサポートしていますか？',
        faq6Answer:
            'Veo 3.1は中国語、英語、日本語、韓国語などの主流言語を含む複数の言語のプロンプトをサポートしています。AIモデルは異なる言語のクリエイティブな説明を正確に理解し、対応する動画コンテンツを生成できます。',
        faq7Question: 'Veo 3.1で生成された動画を商用利用できますか？',
        faq7Answer:
            '商用利用権はWeryAIの利用規約とサブスクリプションプランに依存します。商用利用前にプラットフォームの使用契約を確認するか、詳細なライセンス情報についてカスタマーサービスに連絡することをお勧めします。',

        // CTAセクション
        ctaTitle: '作成を開始する準備はできましたか？',
        ctaSubtitle: '今すぐVeo 3.1を試して、アイデアを素晴らしい動画に変換',
        ctaDescription:
            'Veo 3.1の強力な機能を体験し、あなたの創造的なアイデアをプロフェッショナルな動画コンテンツに変換',
        ctaButton: 'WeryAIでVeo 3.1を試す',
        ctaNote: 'クレジットカード不要',

        // 動画再生関連
        videoNotSupported: 'お使いのブラウザは動画再生をサポートしていません',
        videoUnsupported: 'お使いのブラウザは動画再生をサポートしていません',
        videoLoadError: '動画の読み込みに失敗しました',
        videoReload: '再読み込み',
    },
    ko: {
        // 페이지 제목 및 설명
        pageTitle:
            'Google Veo 3.1 AI 비디오 생성기 - 무료 최신 AI 비디오 제작 도구 체험',
        pageDescription:
            'Google Veo 3.1 AI 비디오 생성기를 체험하세요. 프레임 연결, 소재에서 비디오, 네이티브 오디오 생성 등의 핵심 기능을 지원합니다. 微鲤AI 플랫폼에서 무료로 체험하고 전문 AI 비디오 콘텐츠를 만들어보세요.',
        pageKeywords:
            'Veo 3.1, Google AI 비디오 생성기, AI 비디오 제작, 인공지능 비디오, 비디오 생성 도구, 무료 AI 비디오, 微鲤AI, 비디오 제작',

        // 생성기 섹션
        generatorTitle: 'Google Veo 3.1 AI 비디오 생성기',
        generatorDescription:
            'Google Veo 3.1은 고품질의 사실적인 오디오 비주얼 콘텐츠를 생성하는 최첨단 AI 비디오 모델입니다. Veo 3의 업그레이드 버전으로 품질과 기능이 크게 향상되었습니다. 微鲤AI 비디오 생성기에서 Veo 3.1을 무료로 체험하세요!',

        // 탭
        tabImageToVideo: '이미지에서 비디오',
        tabTextToVideo: '텍스트에서 비디오',

        // 핵심 기능 섹션
        coreFeaturesTitle: 'Veo 3.1 핵심 기능',
        coreFeaturesSubtitle:
            'Google Veo 3.1 AI 비디오 생성기의 핵심 기능을 탐색하고 차세대 AI 비디오 제작을 경험하세요',

        // 프레임 연결 기능
        frameToVideoTitle: '프레임 연결 (시작 및 끝 프레임 제어)',
        frameToVideoDescription:
            'Veo 3.1은 시작 및 끝 프레임 제어를 통한 비디오 생성을 지원하여 비디오의 시작과 끝 프레임을 정확하게 제어하고 더 일관된 비주얼 스토리텔링을 구현합니다.',
        frameToFrameTitle: '프레임 간 제어',
        frameToFrameDescription:
            '시작 및 끝 프레임을 지정하여 비디오 생성을 제어하고 부드러운 전환과 일관된 비주얼 내러티브를 생성합니다.',

        // 소재에서 비디오 기능
        materialToVideoTitle: '소재에서 비디오',
        materialToVideoDescription:
            '기존 소재 및 참고 자료를 기반으로 고품질 비디오를 생성하여 콘텐츠의 지능적인 재창작과 비주얼 업그레이드를 실현합니다.',

        // 네이티브 오디오 생성 기능
        nativeAudioTitle: '네이티브 오디오 생성',
        nativeAudioDescription:
            'Veo 3.1은 오디오를 생성하고 생성된 비디오에 통합하여 완벽한 오디오-비주얼 동기화를 달성하고 더 매력적이고 사실적인 콘텐츠를 제공합니다.',

        // 일관된 캐릭터 기능
        consistentCharacterTitle: '일관된 캐릭터 표현',
        consistentCharacterDescription:
            '캐릭터가 다른 장면과 샷에서 높은 일관성을 유지하여 일관된 비주얼 경험을 창출합니다.',

        // 고급 프롬프트 기능
        advancedPromptTitle: '고급 프롬프트 이해',
        advancedPromptDescription:
            '복잡한 프롬프트를 정확하게 해석하고 창의적인 의도를 정확하게 이해하여 텍스트 설명을 생생한 비주얼 장면으로 변환합니다.',

        // 장면 확장 기능
        sceneExpansionTitle: '강력한 장면 확장',
        sceneExpansionDescription:
            '비디오 장면을 지능적으로 확장하여 더 풍부한 비주얼 콘텐츠를 생성하고 창의성이 시간과 공간의 제한을 돌파하도록 합니다.',

        // 사용 방법 섹션
        howToUseTitle: '사용 방법',
        howToUseSubtitle: '3단계로 시작하는 제작',
        step1Title: '모델 선택',
        step1Description: 'AI 비디오 도구에서 Veo 3.1 모델 선택',
        step2Title: '콘텐츠 입력',
        step2Description: '텍스트 프롬프트 입력 또는 참조 이미지 업로드',
        step3Title: '비디오 생성',
        step3Description: '생성 버튼 클릭 후 대기 및 비디오 다운로드',

        // YouTube 비디오 섹션
        youtubeVideosTitle: 'Google Veo 3.1 AI 비디오 모델 관련 YouTube 비디오',
        youtubeVideoTitle: 'Google Veo 3.1 AI 비디오 모델 관련 YouTube 비디오',

        // X 게시물 섹션
        xPostsTitle: 'Veo 3.1 AI 비디오 모델 관련 X 게시물',

        // 다른 모델 탐색 섹션
        exploreOtherModelsTitle: '다른 Veo 모델 탐색',
        veo2Title: 'Google Veo 2 AI 비디오 생성기',
        veo3Title: 'Google Veo 3 AI 비디오 생성기',
        veo3FastTitle: 'Google Veo 3 Fast AI 비디오 생성기',

        // FAQ 섹션
        faqTitle: '자주 묻는 질문',
        faq1Question: 'Google Veo 3.1이란 무엇인가요?',
        faq1Answer:
            'Google Veo 3.1은 Google DeepMind가 개발한 최신 AI 비디오 생성 모델로 Veo 3의 업그레이드 버전입니다. 텍스트 프롬프트 또는 참조 이미지를 기반으로 고품질의 사실적인 비디오 콘텐츠를 생성할 수 있으며, 프레임 연결, 소재에서 비디오, 네이티브 오디오 생성 등의 고급 기능을 지원합니다.',
        faq2Question: 'Veo 3.1과 Veo 3의 차이점은 무엇인가요?',
        faq2Answer:
            'Veo 3.1은 Veo 3의 향상된 버전으로, 주요 개선 사항은 다음과 같습니다: 더 강력한 프레임 연결 기능, 더 나은 소재에서 비디오 효과, 더 스마트한 장면 확장, 더 정확한 프롬프트 이해, 그리고 더 높은 비디오 생성 품질. Veo 3.1은 Veo 3의 핵심 장점을 유지하면서 창의적 유연성과 출력 품질을 더욱 향상시켰습니다.',
        faq3Question: 'Veo 3.1은 얼마나 긴 비디오를 생성할 수 있나요?',
        faq3Answer:
            'Veo 3.1은 다양한 길이의 비디오 생성을 지원하며, 선택한 구성 및 플랫폼 제한에 따라 달라집니다. 微鲤AI 플랫폼에서는 몇 초에서 몇 분까지의 비디오 콘텐츠를 생성할 수 있습니다.',
        faq4Question: 'WeryAI에서 Veo 3.1을 어떻게 사용하나요?',
        faq4Answer:
            '매우 간단합니다: 1) 微鲤AI 플랫폼에 접속하여 Veo 3.1 모델 선택; 2) 텍스트 프롬프트 입력 또는 참조 이미지 업로드; 3) 생성 버튼 클릭 후 AI 생성 대기; 4) 비디오 다운로드 또는 공유.',
        faq5Question: 'Veo 3.1로 생성된 비디오에 워터마크가 포함되나요?',
        faq5Answer:
            '이는 微鲤AI 구독 플랜에 따라 다릅니다. 무료 사용자가 생성한 비디오에는 워터마크가 포함될 수 있지만, 유료 구독자는 워터마크 없는 고품질 비디오를 얻을 수 있습니다.',
        faq6Question: 'Veo 3.1은 어떤 언어의 프롬프트를 지원하나요?',
        faq6Answer:
            'Veo 3.1은 중국어, 영어, 일본어, 한국어 등 주요 언어를 포함한 여러 언어의 프롬프트를 지원합니다. AI 모델은 다양한 언어의 창의적 설명을 정확하게 이해하고 해당 비디오 콘텐츠를 생성할 수 있습니다.',
        faq7Question: 'Veo 3.1로 생성된 비디오를 상업적으로 사용할 수 있나요?',
        faq7Answer:
            '상업적 사용권은 WeryAI의 서비스 약관 및 구독 플랜에 따라 다릅니다. 상업적 사용 전에 플랫폼의 사용 계약을 확인하거나 상세한 라이선스 정보에 대해 고객 서비스에 문의하는 것이 좋습니다.',

        // CTA 섹션
        ctaTitle: '제작을 시작할 준비가 되셨나요?',
        ctaSubtitle:
            '지금 Veo 3.1을 체험하고 아이디어를 멋진 비디오로 변환하세요',
        ctaDescription:
            'Veo 3.1의 강력한 기능을 경험하고 창의적인 아이디어를 전문적인 비디오 콘텐츠로 변환하세요',
        ctaButton: 'WeryAI에서 Veo 3.1 체험하기',
        ctaNote: '신용카드 불필요',

        // 비디오 재생 관련
        videoNotSupported: '브라우저가 비디오 재생을 지원하지 않습니다',
        videoUnsupported: '브라우저가 비디오 재생을 지원하지 않습니다',
        videoLoadError: '비디오 로드 실패',
        videoReload: '다시 로드',
    },
    tw: {
        // 頁面標題和描述
        pageTitle: 'Google Veo 3.1 影片產生器 - 免費體驗最新 AI 影片創作工具',
        pageDescription:
            '體驗 Google Veo 3.1 影片產生器，支援連幀成片、素材生影片、原生音訊生成等核心功能。在 微鲤AI 平台免費試用，創造專業級 AI 影片內容。',
        pageKeywords:
            'Veo 3.1, Google AI影片產生器, AI影片創作, 人工智慧影片, 影片生成工具, 免費AI影片, 微鲤AI, 影片製作',

        // 生成器部分
        generatorTitle: 'Google Veo 3.1 影片產生器',
        generatorDescription:
            'Google Veo 3.1 是一款最先進的 AI 影片模型，能夠生成高品質、逼真自然的音訊影片。它是 Veo 3 的升級版本，在品質和功能上都有顯著提升。快來 微鲤AI 影片產生器免費體驗 Veo 3.1！',

        // 標籤頁
        tabImageToVideo: '圖生影片',
        tabTextToVideo: '文生影片',

        // 核心功能部分
        coreFeaturesTitle: 'Veo 3.1 核心功能特性',
        coreFeaturesSubtitle:
            '深入了解 Google Veo 3.1 影片產生器的核心功能，體驗下一代 AI 影片創作技術',

        // 連幀成片功能
        frameToVideoTitle: '連幀成片（首尾幀控制）',
        frameToVideoDescription:
            'Veo 3.1 支援透過首尾幀控制影片生成，讓您精確掌控影片的起始和結束畫面，創造更具連貫性的視覺敘事。',
        frameToFrameTitle: '幀間控制',
        frameToFrameDescription:
            '透過指定首尾幀來控制影片生成，建立流暢的過渡和連貫的視覺敘事。',

        // 素材生影片功能
        materialToVideoTitle: '素材生影片',
        materialToVideoDescription:
            '基於現有素材和參考材料建立高品質影片，實現素材的智慧化二次創作和視覺升級。',

        // 原生音訊生成功能
        nativeAudioTitle: '原生音訊生成',
        nativeAudioDescription:
            'Veo 3.1 建立音訊並將其整合到生成的影片中，實現完美的視聽同步體驗，讓您的影片更具吸引力和真實感。',

        // 一致角色功能
        consistentCharacterTitle: '一致的角色表現',
        consistentCharacterDescription:
            '確保角色在不同場景和鏡頭中保持高度一致的外觀和特徵，創造連貫的視覺體驗。',

        // 高級提示理解功能
        advancedPromptTitle: '高級提示詞理解',
        advancedPromptDescription:
            '高精度地解讀複雜提示詞，準確理解您的創意意圖，將文字描述轉化為生動的視覺畫面。',

        // 場景擴展功能
        sceneExpansionTitle: '強大的場景擴展',
        sceneExpansionDescription:
            '智慧擴充影片場景，生成更豐富的視覺內容，讓您的創意突破時間和空間的限制。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        howToUseSubtitle: '簡單三步，開始創作',
        step1Title: '選擇模型',
        step1Description: '在 AI 影片工具中選擇 Veo 3.1 模型',
        step2Title: '輸入內容',
        step2Description: '輸入提示詞或上傳參考圖像',
        step3Title: '生成影片',
        step3Description: '點擊生成按鈕，等待並下載您的影片',

        // YouTube 影片部分
        youtubeVideosTitle: 'Google Veo 3.1 影片模型相關 YouTube 影片',
        youtubeVideoTitle: 'Google Veo 3.1 影片模型相關 YouTube 影片',

        // X Posts 部分
        xPostsTitle: '關於 Veo 3.1 AI 影片模型的 X 推文',

        // 探索其他模型部分
        exploreOtherModelsTitle: '探索其他 Veo 模型',
        veo2Title: 'Google Veo 2 AI影片產生器',
        veo3Title: 'Google Veo 3 AI影片產生器',
        veo3FastTitle: 'Google Veo 3 Fast AI影片產生器',

        // FAQ 部分
        faqTitle: '常見問題解答',
        faq1Question: '什麼是 Google Veo 3.1？',
        faq1Answer:
            'Google Veo 3.1 是 Google DeepMind 開發的最新一代 AI 影片生成模型，是 Veo 3 的升級版本。它能夠根據文本提示或參考圖像生成高品質、逼真的影片內容，支援連幀成片、素材生影片、原生音訊生成等先進功能。',
        faq2Question: 'Veo 3.1 與 Veo 3 有什麼區別？',
        faq2Answer:
            'Veo 3.1 是 Veo 3 的增強版本，主要改善包括：更強的連幀成片能力、更好的素材生影片效果、更智慧的場景擴展功能、更精準的提示詞理解、以及更高的影片生成品質。Veo 3.1 在保持 Veo 3 核心優勢的基礎上，進一步提升了創作靈活性和輸出品質。',
        faq3Question: 'Veo 3.1 可以生成多長的影片？',
        faq3Answer:
            'Veo 3.1 支援生成不同時長的影片，具體時長取決於您選擇的配置和平台限制。在 微鲤AI 平台上，您可以根據需求生成從幾秒到數分鐘不等的影片內容。',
        faq4Question: '如何在 微鲤AI 上使用 Veo 3.1？',
        faq4Answer:
            '使用非常簡單：1) 訪問 微鲤AI 平台並選擇 Veo 3.1 模型；2) 輸入您的文本提示或上傳參考圖像；3) 點擊生成按鈕，等待 AI 創作完成；4) 下載或分享您的影片。',
        faq5Question: 'Veo 3.1 生成的影片是否包含浮水印？',
        faq5Answer:
            '這取決於您的 微鲤AI 訂閱計劃。免費使用者生成的影片可能包含浮水印，而付費訂閱使用者則可以獲得無浮水印的高品質影片輸出。',
        faq6Question: 'Veo 3.1 支援哪些語言的提示詞？',
        faq6Answer:
            'Veo 3.1 支援多種語言的提示詞輸入，包括中文、英文、日文、韓文等主流語言。AI 模型能夠準確理解不同語言的創意描述並生成相應的影片內容。',
        faq7Question: '我可以商用 Veo 3.1 生成的影片嗎？',
        faq7Answer:
            '影片的商業使用權利取決於 微鲤AI 的服務條款和您的訂閱計劃。建議在商業使用前查看平台的使用協議，或聯繫客服了解詳細的授權資訊。',

        // CTA 部分
        ctaTitle: '準備開始創作了嗎？',
        ctaSubtitle: '立即體驗 Veo 3.1，將您的創意轉化為精彩影片',
        ctaDescription:
            '體驗 Veo 3.1 的強大功能，將您的創意想法轉化為專業影片內容',
        ctaButton: '開始創作',
        ctaNote: '無需信用卡 · 新使用者免費體驗',

        // 影片播放相關
        videoNotSupported: '您的瀏覽器不支援影片播放',
        videoUnsupported: '您的瀏覽器不支援影片播放',
        videoLoadError: '影片載入失敗',
        videoReload: '重新載入',
    },
    pl: {
        // Tytuł i opis strony
        pageTitle: 'Generator wideo Google Veo 3.1 - Wypróbuj za darmo najnowocześniejsze narzędzie do tworzenia wideo AI',
        pageDescription:
            'Poznaj generator wideo Google Veo 3.1, obsługujący kluczowe funkcje, takie jak łączenie klatek, tworzenie wideo z materiałów oraz natywne generowanie dźwięku. Wypróbuj za darmo na platformie 微鲤AI i twórz profesjonalne treści wideo AI.',
        pageKeywords:
            'Veo 3.1, generator wideo Google AI, tworzenie wideo AI, wideo ze sztuczną inteligencją, narzędzie do generowania wideo, darmowe wideo AI, 微鲤AI, produkcja wideo',

        // Sekcja generatora
        generatorTitle: 'Generator wideo Google Veo 3.1 AI',
        generatorDescription:
            'Google Veo 3.1 to najbardziej zaawansowany model wideo AI, który generuje wysokiej jakości, realistyczne treści audiowizualne. Jest to ulepszona wersja Veo 3 ze znaczącymi usprawnieniami w jakości i funkcjach. Wypróbuj Veo 3.1 za darmo w generatorze wideo 微鲤AI!',

        // Karty
        tabImageToVideo: 'Obraz na wideo',
        tabTextToVideo: 'Tekst na wideo',

        // Sekcja kluczowych funkcji
        coreFeaturesTitle: 'Kluczowe funkcje Veo 3.1',
        coreFeaturesSubtitle:
            'Poznaj podstawowe możliwości generatora wideo Google Veo 3.1 AI i doświadcz tworzenia wideo AI nowej generacji',

        // Funkcja klatka do wideo
        frameToVideoTitle: 'Klatka do wideo (kontrola pierwszej i ostatniej klatki)',
        frameToVideoDescription:
            'Veo 3.1 obsługuje generowanie wideo poprzez kontrolę pierwszej i ostatniej klatki, co pozwala na precyzyjne sterowanie początkowym i końcowym obrazem wideo dla bardziej spójnej narracji wizualnej.',
        frameToFrameTitle: 'Kontrola międzyklatkowa',
        frameToFrameDescription:
            'Kontroluj generowanie wideo, określając pierwszą i ostatnią klatkę, tworząc płynne przejścia i spójne narracje wizualne.',

        // Funkcja materiał do wideo
        materialToVideoTitle: 'Materiał na wideo',
        materialToVideoDescription:
            'Twórz wysokiej jakości filmy wideo na podstawie istniejących materiałów i referencji, umożliwiając inteligentne ponowne tworzenie i wizualne ulepszanie Twoich treści.',

        // Funkcja natywnego generowania dźwięku
        nativeAudioTitle: 'Natywne generowanie dźwięku',
        nativeAudioDescription:
            'Veo 3.1 tworzy dźwięk i integruje go z wygenerowanymi filmami, osiągając idealną synchronizację audio-wizualną dla bardziej angażujących i realistycznych treści.',

        // Funkcja spójności postaci
        consistentCharacterTitle: 'Spójne zachowanie postaci',
        consistentCharacterDescription:
            'Zapewnij postaciom wysoce spójny wygląd i cechy w różnych scenach i ujęciach, tworząc jednolite wrażenia wizualne.',

        // Zaawansowana funkcja rozumienia promptów
        advancedPromptTitle: 'Zaawansowane rozumienie promptów',
        advancedPromptDescription:
            'Precyzyjnie interpretuj złożone prompty, dokładnie zrozum swoje intencje twórcze i przekształcaj opisy tekstowe w żywe sceny wizualne.',

        // Funkcja rozszerzania sceny
        sceneExpansionTitle: 'Potężne rozszerzanie sceny',
        sceneExpansionDescription:
            'Inteligentnie rozszerzaj sceny wideo, aby generować bogatszą zawartość wizualną, pozwalając swojej kreatywności przełamywać ograniczenia czasu i przestrzeni.',

        // Sekcja jak używać
        howToUseTitle: 'Jak używać',
        howToUseSubtitle: 'Zacznij tworzyć w trzech prostych krokach',
        step1Title: 'Wybierz model',
        step1Description: 'Wybierz model Veo 3.1 w narzędziach wideo AI',
        step2Title: 'Wprowadź treść',
        step2Description: 'Wpisz prompt tekstowy lub prześlij obraz referencyjny',
        step3Title: 'Generuj wideo',
        step3Description: 'Kliknij przycisk generowania, zaczekaj i pobierz swoje wideo',

        // Sekcja filmów YouTube
        youtubeVideosTitle: 'Filmy YouTube o modelu wideo Google Veo 3.1 AI',
        youtubeVideoTitle: 'Filmy YouTube o modelu wideo Google Veo 3.1 AI',

        // Sekcja postów X
        xPostsTitle: 'Posty X o modelu wideo Google Veo 3.1 AI',

        // Sekcja odkrywania innych modeli
        exploreOtherModelsTitle: 'Poznaj inne modele Veo',
        veo2Title: 'Generator wideo Google Veo 2 AI',
        veo3Title: 'Generator wideo Google Veo 3 AI',
        veo3FastTitle: 'Generator wideo Google Veo 3 Fast AI',

        // Sekcja FAQ
        faqTitle: 'Często zadawane pytania',
        faq1Question: 'Co to jest Google Veo 3.1?',
        faq1Answer:
            'Google Veo 3.1 to najnowszej generacji model do generowania wideo AI opracowany przez Google DeepMind, będący ulepszoną wersją Veo 3. Potrafi on generować wysokiej jakości, realistyczne treści wideo na podstawie promptów tekstowych lub obrazów referencyjnych, obsługując zaawansowane funkcje, takie jak łączenie klatek, tworzenie wideo z materiałów oraz natywne generowanie dźwięku.',
        faq2Question: 'Jaka jest różnica między Veo 3.1 a Veo 3?',
        faq2Answer:
            'Veo 3.1 to ulepszona wersja Veo 3, z kluczowymi usprawnieniami obejmującymi: silniejsze możliwości łączenia klatek, lepsze efekty tworzenia wideo z materiałów, inteligentniejsze rozszerzanie sceny, bardziej precyzyjne rozumienie promptów oraz wyższą jakość generowania wideo. Veo 3.1 dodatkowo zwiększa elastyczność twórczą i jakość wyjściową, zachowując jednocześnie podstawowe zalety Veo 3.',
        faq3Question: 'Jak długie filmy może generować Veo 3.1?',
        faq3Answer:
            'Veo 3.1 obsługuje generowanie filmów o różnej długości, w zależności od wybranej konfiguracji i ograniczeń platformy. Na platformie 微鲤AI można generować filmy trwające od kilku sekund do kilku minut.',
        faq4Question: 'Jak korzystać z Veo 3.1 w 微鲤AI?',
        faq4Answer:
            'Korzystanie jest bardzo proste: 1) Odwiedź platformę 微鲤AI i wybierz model Veo 3.1; 2) Wpisz swój prompt tekstowy lub prześlij obraz referencyjny; 3) Kliknij przycisk generowania i poczekaj na zakończenie tworzenia przez AI; 4) Pobierz lub udostępnij swój film.',
        faq5Question: 'Czy filmy wygenerowane przez Veo 3.1 zawierają znaki wodne?',
        faq5Answer:
            'Zależy to od Twojego planu subskrypcji 微鲤AI. Filmy generowane przez darmowych użytkowników mogą zawierać znaki wodne, podczas gdy płatni subskrybenci mogą otrzymać wysokiej jakości filmy bez znaków wodnych.',
        faq6Question: 'Jakie języki obsługuje Veo 3.1 w promptach?',
        faq6Answer:
            'Veo 3.1 obsługuje prompty w wielu językach, w tym chińskim, angielskim, japońskim, koreańskim i innych popularnych językach. Model AI potrafi dokładnie zrozumieć opisy kreatywne w różnych językach i wygenerować odpowiednią zawartość wideo.',
        faq7Question: 'Czy mogę używać filmów wygenerowanych przez Veo 3.1 komercyjnie?',
        faq7Answer:
            'Prawa do użytku komercyjnego zależą od warunków świadczenia usług 微鲤AI i Twojego planu subskrypcji. Zalecamy sprawdzenie umowy użytkowania platformy przed użyciem komercyjnym lub kontakt z obsługą klienta w celu uzyskania szczegółowych informacji o licencjonowaniu.',

        // Sekcja CTA
        ctaTitle: 'Gotowy, by zacząć tworzyć?',
        ctaSubtitle: 'Wypróbuj Veo 3.1 już teraz i przekształć swoje pomysły w niesamowite filmy',
        ctaDescription:
            'Poznaj moc Veo 3.1 i zamień swoje kreatywne pomysły w profesjonalne treści wideo.',
        ctaButton: 'Zacznij tworzyć',
        ctaNote: 'Karta kredytowa nie jest wymagana · Darmowy okres próbny dla nowych użytkowników',

        // Powiązane z odtwarzaniem wideo
        videoNotSupported: 'Twoja przeglądarkarka nie obsługuje odtwarzania wideo',
        videoUnsupported: 'Twoja przeglądarkarka nie obsługuje odtwarzania wideo',
        videoLoadError: 'Nie udało się załadować wideo',
        videoReload: 'Załaduj ponownie',
    },
    es: {
        // Título y descripción de la página
        pageTitle:
            'Generador de Video IA Google Veo 3.1 - Herramienta Avanzada de Creación de Video IA Gratis',
        pageDescription:
            'Experimenta el generador de video IA Google Veo 3.1 con fotograma a video, material a video, generación de audio nativo y más. Pruébalo gratis en la plataforma 微鲤AI para crear videos IA profesionales.',
        pageKeywords:
            'Veo 3.1, generador de video IA de Google, creación de video IA, video de inteligencia artificial, herramienta de generación de video, video IA gratis, 微鲤AI, producción de video',

        // Sección del generador
        generatorTitle: 'Generador de Video IA Google Veo 3.1',
        generatorDescription:
            'Google Veo 3.1 es el modelo de video IA más avanzado que genera contenido audiovisual de alta calidad y realista. Es una versión mejorada de Veo 3 con mejoras significativas en calidad y funciones. ¡Prueba Veo 3.1 gratis en el generador de video 微鲤AI!',

        // Pestañas
        tabImageToVideo: 'Imagen a Video',
        tabTextToVideo: 'Texto a Video',

        // Sección de características principales
        coreFeaturesTitle: 'Características Principales de Veo 3.1',
        coreFeaturesSubtitle:
            'Explora las capacidades principales del generador de video IA Google Veo 3.1 y experimenta la creación de video IA de próxima generación',

        // Función de fotograma a video
        frameToVideoTitle:
            'Fotograma a Video (Control de Primer y Último Fotograma)',
        frameToVideoDescription:
            'Veo 3.1 soporta generación de video mediante control de primer y último fotograma, permitiéndote controlar con precisión los fotogramas inicial y final de tu video para una narración visual más coherente.',
        frameToFrameTitle: 'Control Fotograma a Fotograma',
        frameToFrameDescription:
            'Controla la generación de video especificando el primer y último fotograma, creando transiciones suaves y narrativas visuales coherentes.',

        // Función de material a video
        materialToVideoTitle: 'Material a Video',
        materialToVideoDescription:
            'Crea videos de alta calidad basados en materiales y referencias existentes, permitiendo recreación inteligente y mejora visual de tu contenido.',

        // Función de generación de audio nativo
        nativeAudioTitle: 'Generación de Audio Nativo',
        nativeAudioDescription:
            'Veo 3.1 crea audio y lo integra en videos generados, logrando sincronización audiovisual perfecta para contenido más atractivo y realista.',

        // Función de personaje consistente
        consistentCharacterTitle: 'Rendimiento de Personaje Consistente',
        consistentCharacterDescription:
            'Asegura que los personajes mantengan apariencia y características altamente consistentes en diferentes escenas y tomas, creando una experiencia visual coherente.',

        // Función de prompt avanzado
        advancedPromptTitle: 'Comprensión Avanzada de Prompts',
        advancedPromptDescription:
            'Interpreta con precisión prompts complejos, comprende con exactitud tu intención creativa y transforma descripciones de texto en escenas visuales vívidas.',

        // Función de expansión de escenas
        sceneExpansionTitle: 'Expansión de Escenas Poderosa',
        sceneExpansionDescription:
            'Expande inteligentemente las escenas de video para generar contenido visual más rico, permitiendo que tu creatividad rompa las limitaciones de tiempo y espacio.',

        // Sección cómo usar
        howToUseTitle: 'Cómo Usar',
        howToUseSubtitle: 'Comienza a Crear en Tres Simples Pasos',
        step1Title: 'Seleccionar Modelo',
        step1Description:
            'Elige el modelo Veo 3.1 en las herramientas de video IA',
        step2Title: 'Introducir Contenido',
        step2Description:
            'Introduce prompt de texto o sube imagen de referencia',
        step3Title: 'Generar Video',
        step3Description:
            'Haz clic en el botón generar, espera y descarga tu video',

        // Sección de videos de YouTube
        youtubeVideosTitle:
            'Videos de YouTube sobre el Modelo de Video IA Google Veo 3.1',
        youtubeVideoTitle:
            'Videos de YouTube sobre el Modelo de Video IA Google Veo 3.1',

        // Sección de publicaciones X
        xPostsTitle: 'Publicaciones de X sobre el Modelo de Video IA Veo 3.1',

        // Sección explorar otros modelos
        exploreOtherModelsTitle: 'Explorar Otros Modelos Veo',
        veo2Title: 'Generador de Video IA Google Veo 2',
        veo3Title: 'Generador de Video IA Google Veo 3',
        veo3FastTitle: 'Generador de Video IA Google Veo 3 Fast',

        // Sección FAQ
        faqTitle: 'Preguntas Frecuentes',
        faq1Question: '¿Qué es Google Veo 3.1?',
        faq1Answer:
            'Google Veo 3.1 es el último modelo de generación de video IA desarrollado por Google DeepMind, una versión mejorada de Veo 3. Puede generar contenido de video de alta calidad y realista basado en prompts de texto o imágenes de referencia, soportando funciones avanzadas como fotograma a video, material a video y generación de audio nativo.',
        faq2Question: '¿Cuál es la diferencia entre Veo 3.1 y Veo 3?',
        faq2Answer:
            'Veo 3.1 es una versión mejorada de Veo 3, con mejoras clave que incluyen: capacidades más fuertes de fotograma a video, mejores efectos de material a video, funcionalidad más inteligente de expansión de escenas, comprensión de prompts más precisa y mayor calidad de generación de video. Veo 3.1 mejora aún más la flexibilidad creativa y la calidad de salida mientras mantiene las ventajas principales de Veo 3.',
        faq3Question: '¿Cuánto pueden durar los videos generados por Veo 3.1?',
        faq3Answer:
            'Veo 3.1 soporta la generación de videos de varias longitudes, dependiendo de su configuración elegida y limitaciones de la plataforma. En la plataforma 微鲤AI, puede generar contenido de video que va desde unos pocos segundos hasta varios minutos.',
        faq4Question: '¿Cómo uso Veo 3.1 en 微鲤AI?',
        faq4Answer:
            'Es muy simple: 1) Visita la plataforma 微鲤AI y selecciona el modelo Veo 3.1; 2) Introduce tu prompt de texto o sube imagen de referencia; 3) Haz clic en el botón generar y espera la creación de IA; 4) Descarga o comparte tu video.',
        faq5Question:
            '¿Los videos generados por Veo 3.1 contienen marcas de agua?',
        faq5Answer:
            'Esto depende de tu plan de suscripción de 微鲤AI. Los videos generados por usuarios gratuitos pueden contener marcas de agua, mientras que los suscriptores de pago pueden obtener videos de alta calidad sin marcas de agua.',
        faq6Question: '¿Qué idiomas soporta Veo 3.1 para prompts?',
        faq6Answer:
            'Veo 3.1 soporta prompts en múltiples idiomas, incluyendo chino, inglés, japonés, coreano y otros idiomas principales. El modelo IA puede comprender con precisión descripciones creativas en diferentes idiomas y generar contenido de video correspondiente.',
        faq7Question:
            '¿Puedo usar videos generados por Veo 3.1 comercialmente?',
        faq7Answer:
            'Los derechos de uso comercial dependen de los términos de servicio de 微鲤AI y tu plan de suscripción. Recomendamos revisar el acuerdo de uso de la plataforma antes del uso comercial, o contactar al servicio al cliente para obtener información detallada de licencias.',

        // Sección CTA
        ctaTitle: '¿Listo para Comenzar a Crear?',
        ctaSubtitle:
            'Prueba Veo 3.1 ahora y transforma tus ideas en videos impresionantes',
        ctaDescription:
            'Experimenta el poder de Veo 3.1 y convierte tus ideas creativas en contenido de video profesional.',
        ctaButton: 'Prueba Veo 3.1 en 微鲤AI',
        ctaNote: 'No se requiere tarjeta de crédito',

        // Relacionado con reproducción de video
        videoNotSupported: 'Su navegador no soporta reproducción de video',
        videoUnsupported: 'Su navegador no soporta reproducción de video',
        videoLoadError: 'Error al cargar el video',
        videoReload: 'Recargar',
    },
    fr: {
        // Titre et description de la page
        pageTitle:
            'Générateur Vidéo IA Google Veo 3.1 - Outil Avancé de Création Vidéo IA Gratuit',
        pageDescription:
            'Découvrez le générateur vidéo IA Google Veo 3.1 avec image par image vers vidéo, matériel vers vidéo, génération audio native et plus. Essayez-le gratuitement sur la plateforme 微鲤AI pour créer des vidéos IA professionnelles.',
        pageKeywords:
            'Veo 3.1, générateur vidéo IA Google, création vidéo IA, vidéo intelligence artificielle, outil génération vidéo, vidéo IA gratuite, 微鲤AI, production vidéo',

        // Section du générateur
        generatorTitle: 'Générateur Vidéo IA Google Veo 3.1',
        generatorDescription:
            "Google Veo 3.1 est le modèle vidéo IA le plus avancé qui génère du contenu audiovisuel de haute qualité et réaliste. C'est une version améliorée de Veo 3 avec des améliorations significatives en qualité et fonctionnalités. Essayez Veo 3.1 gratuitement sur le générateur vidéo 微鲤AI !",

        // Onglets
        tabImageToVideo: 'Image vers Vidéo',
        tabTextToVideo: 'Texte vers Vidéo',

        // Section des fonctionnalités principales
        coreFeaturesTitle: 'Fonctionnalités Principales de Veo 3.1',
        coreFeaturesSubtitle:
            'Explorez les capacités principales du générateur vidéo IA Google Veo 3.1 et découvrez la création vidéo IA de nouvelle génération',

        // Fonction image par image vers vidéo
        frameToVideoTitle:
            'Image par Image vers Vidéo (Contrôle de la Première et Dernière Image)',
        frameToVideoDescription:
            'Veo 3.1 prend en charge la génération vidéo via le contrôle de la première et dernière image, vous permettant de contrôler précisément les images de début et de fin de votre vidéo pour une narration visuelle plus cohérente.',
        frameToFrameTitle: 'Contrôle Image par Image',
        frameToFrameDescription:
            'Contrôlez la génération vidéo en spécifiant la première et la dernière image, créant des transitions fluides et des récits visuels cohérents.',

        // Fonction matériel vers vidéo
        materialToVideoTitle: 'Matériel vers Vidéo',
        materialToVideoDescription:
            'Créez des vidéos de haute qualité basées sur des matériaux et références existants, permettant une recréation intelligente et une amélioration visuelle de votre contenu.',

        // Fonction de génération audio native
        nativeAudioTitle: 'Génération Audio Native',
        nativeAudioDescription:
            "Veo 3.1 crée de l'audio et l'intègre dans les vidéos générées, réalisant une synchronisation audiovisuelle parfaite pour un contenu plus engageant et réaliste.",

        // Fonction personnage cohérent
        consistentCharacterTitle: 'Performance de Personnage Cohérente',
        consistentCharacterDescription:
            'Assure que les personnages maintiennent une apparence et des caractéristiques hautement cohérentes à travers différentes scènes et prises, créant une expérience visuelle cohérente.',

        // Fonction prompt avancé
        advancedPromptTitle: 'Compréhension Avancée des Prompts',
        advancedPromptDescription:
            'Interprète avec précision les prompts complexes, comprend exactement votre intention créative et transforme les descriptions textuelles en scènes visuelles vivantes.',

        // Fonction d'expansion de scène
        sceneExpansionTitle: 'Expansion de Scène Puissante',
        sceneExpansionDescription:
            "Étend intelligemment les scènes vidéo pour générer un contenu visuel plus riche, permettant à votre créativité de dépasser les limites de temps et d'espace.",

        // Section comment utiliser
        howToUseTitle: 'Comment Utiliser',
        howToUseSubtitle: 'Commencez à Créer en Trois Étapes Simples',
        step1Title: 'Sélectionner le Modèle',
        step1Description:
            'Choisissez le modèle Veo 3.1 dans les outils vidéo IA',
        step2Title: 'Saisir le Contenu',
        step2Description:
            'Entrez le prompt de texte ou téléchargez une image de référence',
        step3Title: 'Générer la Vidéo',
        step3Description:
            'Cliquez sur le bouton générer, attendez et téléchargez votre vidéo',

        // Section vidéos YouTube
        youtubeVideosTitle:
            'Vidéos YouTube sur le Modèle Vidéo IA Google Veo 3.1',
        youtubeVideoTitle:
            'Vidéos YouTube sur le Modèle Vidéo IA Google Veo 3.1',

        // Section publications X
        xPostsTitle: 'Publications X sur le Modèle Vidéo IA Veo 3.1',

        // Section explorer d'autres modèles
        exploreOtherModelsTitle: "Explorer d'Autres Modèles Veo",
        veo2Title: 'Générateur Vidéo IA Google Veo 2',
        veo3Title: 'Générateur Vidéo IA Google Veo 3',
        veo3FastTitle: 'Générateur Vidéo IA Google Veo 3 Fast',

        // Section FAQ
        faqTitle: 'Questions Fréquemment Posées',
        faq1Question: "Qu'est-ce que Google Veo 3.1 ?",
        faq1Answer:
            'Google Veo 3.1 est le dernier modèle de génération vidéo IA développé par Google DeepMind, une version améliorée de Veo 3. Il peut générer du contenu vidéo de haute qualité et réaliste basé sur des prompts textuels ou des images de référence, supportant des fonctionnalités avancées comme image par image vers vidéo, matériel vers vidéo et génération audio native.',
        faq2Question: 'Quelle est la différence entre Veo 3.1 et Veo 3 ?',
        faq2Answer:
            "Veo 3.1 est une version améliorée de Veo 3, avec des améliorations clés incluant : des capacités plus fortes d'image par image vers vidéo, de meilleurs effets de matériel vers vidéo, une expansion de scène plus intelligente, une compréhension des prompts plus précise et une qualité de génération vidéo supérieure. Veo 3.1 améliore encore la flexibilité créative et la qualité de sortie tout en maintenant les avantages principaux de Veo 3.",
        faq3Question: 'Quelle longueur de vidéos Veo 3.1 peut-il générer ?',
        faq3Answer:
            'Veo 3.1 prend en charge la génération de vidéos de différentes longueurs, en fonction de votre configuration choisie et des limitations de la plateforme. Sur la plateforme 微鲤AI, vous pouvez générer du contenu vidéo allant de quelques secondes à plusieurs minutes.',
        faq4Question: 'Comment utiliser Veo 3.1 sur 微鲤AI ?',
        faq4Answer:
            "C'est très simple : 1) Visitez la plateforme 微鲤AI et sélectionnez le modèle Veo 3.1 ; 2) Entrez votre prompt de texte ou téléchargez une image de référence ; 3) Cliquez sur le bouton générer et attendez la création IA ; 4) Téléchargez ou partagez votre vidéo.",
        faq5Question:
            'Les vidéos générées par Veo 3.1 contiennent-elles des filigranes ?',
        faq5Answer:
            "Cela dépend de votre plan d'abonnement 微鲤AI. Les vidéos générées par les utilisateurs gratuits peuvent contenir des filigranes, tandis que les abonnés payants peuvent obtenir des vidéos de haute qualité sans filigranes.",
        faq6Question:
            'Quelles langues Veo 3.1 prend-il en charge pour les prompts ?',
        faq6Answer:
            "Veo 3.1 prend en charge les prompts dans plusieurs langues, y compris le chinois, l'anglais, le japonais, le coréen et d'autres langues principales. Le modèle IA peut comprendre avec précision les descriptions créatives dans différentes langues et générer le contenu vidéo correspondant.",
        faq7Question:
            'Puis-je utiliser commercialement les vidéos générées par Veo 3.1 ?',
        faq7Answer:
            "Les droits d'utilisation commerciale dépendent des conditions de service de 微鲤AI et de votre plan d'abonnement. Nous recommandons de vérifier l'accord d'utilisation de la plateforme avant l'utilisation commerciale, ou de contacter le service client pour des informations détaillées sur les licences.",

        // Section CTA
        ctaTitle: 'Prêt à Commencer à Créer ?',
        ctaSubtitle:
            'Essayez Veo 3.1 maintenant et transformez vos idées en vidéos époustouflantes',
        ctaDescription:
            'Découvrez la puissance de Veo 3.1 et transformez vos idées créatives en contenu vidéo professionnel.',
        ctaButton: 'Essayez Veo 3.1 sur 微鲤AI',
        ctaNote: 'Aucune carte de crédit requise',

        // Lié à la lecture vidéo
        videoNotSupported:
            'Votre navigateur ne prend pas en charge la lecture vidéo',
        videoUnsupported:
            'Votre navigateur ne prend pas en charge la lecture vidéo',
        videoLoadError: 'Échec du chargement de la vidéo',
        videoReload: 'Recharger',
    },
    de: {
        // Seitentitel und Beschreibung
        pageTitle:
            'Google Veo 3.1 KI-Video-Generator - Kostenfreies Fortgeschrittenes KI-Videoerstellungstool',
        pageDescription:
            'Erleben Sie den Google Veo 3.1 KI-Video-Generator mit Frame-zu-Video, Material-zu-Video, nativer Audiogenerierung und mehr. Testen Sie es kostenlos auf der 微鲤AI-Plattform, um professionelle KI-Videos zu erstellen.',
        pageKeywords:
            'Veo 3.1, Google KI-Video-Generator, KI-Videoerstellung, künstliche Intelligenz Video, Video-Generierungstool, kostenloses KI-Video, 微鲤AI, Videoproduktion',

        // Generator-Abschnitt
        generatorTitle: 'Google Veo 3.1 KI-Video-Generator',
        generatorDescription:
            'Google Veo 3.1 ist das fortschrittlichste KI-Videomodell, das hochwertige, realistische audiovisuelle Inhalte generiert. Es ist eine verbesserte Version von Veo 3 mit erheblichen Verbesserungen in Qualität und Funktionen. Testen Sie Veo 3.1 kostenlos auf dem 微鲤AI Video Generator!',

        // Tabs
        tabImageToVideo: 'Bild zu Video',
        tabTextToVideo: 'Text zu Video',

        // Kernfunktionen-Abschnitt
        coreFeaturesTitle: 'Kernfunktionen von Veo 3.1',
        coreFeaturesSubtitle:
            'Erkunden Sie die Kernfähigkeiten des Google Veo 3.1 KI-Videogenerators und erleben Sie die KI-Videoerstellung der nächsten Generation',

        // Frame-zu-Video-Funktion
        frameToVideoTitle:
            'Frame-zu-Video (Kontrolle von Erstem und Letztem Frame)',
        frameToVideoDescription:
            'Veo 3.1 unterstützt Videogenerierung durch Kontrolle von erstem und letztem Frame, sodass Sie die Start- und Endframes Ihres Videos präzise steuern können für kohärenteres visuelles Storytelling.',
        frameToFrameTitle: 'Frame-zu-Frame-Kontrolle',
        frameToFrameDescription:
            'Kontrollieren Sie die Videogenerierung durch Angabe des ersten und letzten Frames, um flüssige Übergänge und kohärente visuelle Erzählungen zu erstellen.',

        // Material-zu-Video-Funktion
        materialToVideoTitle: 'Material zu Video',
        materialToVideoDescription:
            'Erstellen Sie hochwertige Videos basierend auf vorhandenen Materialien und Referenzen, die intelligente Neugestaltung und visuelle Verbesserung Ihrer Inhalte ermöglichen.',

        // Native Audiogenerierungsfunktion
        nativeAudioTitle: 'Native Audiogenerierung',
        nativeAudioDescription:
            'Veo 3.1 erstellt Audio und integriert es in generierte Videos, erreicht perfekte audiovisuelle Synchronisation für ansprechendere und realistischere Inhalte.',

        // Konsistente Charakterfunktion
        consistentCharacterTitle: 'Konsistente Charakterperformance',
        consistentCharacterDescription:
            'Stellt sicher, dass Charaktere über verschiedene Szenen und Aufnahmen hinweg eine hochgradig konsistente Erscheinung und Merkmale beibehalten und ein kohärentes visuelles Erlebnis schaffen.',

        // Erweiterte Prompt-Funktion
        advancedPromptTitle: 'Erweitertes Prompt-Verständnis',
        advancedPromptDescription:
            'Interpretiert präzise komplexe Prompts, versteht genau Ihre kreative Absicht und verwandelt Textbeschreibungen in lebendige visuelle Szenen.',

        // Szenenerweiterungsfunktion
        sceneExpansionTitle: 'Leistungsstarke Szenenerweiterung',
        sceneExpansionDescription:
            'Erweitert intelligent Videoszenen, um reicheren visuellen Inhalt zu generieren, sodass Ihre Kreativität Zeit- und Raumbeschränkungen durchbrechen kann.',

        // Wie zu verwenden-Abschnitt
        howToUseTitle: 'Wie Man Verwendet',
        howToUseSubtitle:
            'Beginnen Sie mit dem Erstellen in Drei Einfachen Schritten',
        step1Title: 'Modell Auswählen',
        step1Description:
            'Wählen Sie das Veo 3.1-Modell in den KI-Videowerkzeugen',
        step2Title: 'Inhalt Eingeben',
        step2Description:
            'Geben Sie Text-Prompt ein oder laden Sie Referenzbild hoch',
        step3Title: 'Video Generieren',
        step3Description:
            'Klicken Sie auf den Generieren-Button, warten Sie und laden Sie Ihr Video herunter',

        // YouTube-Videos-Abschnitt
        youtubeVideosTitle:
            'YouTube-Videos über das Google Veo 3.1 KI-Videomodell',
        youtubeVideoTitle:
            'YouTube-Videos über das Google Veo 3.1 KI-Videomodell',

        // X-Posts-Abschnitt
        xPostsTitle: 'X-Beiträge über das Veo 3.1 KI-Videomodell',

        // Andere Modelle erkunden-Abschnitt
        exploreOtherModelsTitle: 'Andere Veo-Modelle Erkunden',
        veo2Title: 'Google Veo 2 KI-Videogenerator',
        veo3Title: 'Google Veo 3 KI-Videogenerator',
        veo3FastTitle: 'Google Veo 3 Fast KI-Videogenerator',

        // FAQ-Abschnitt
        faqTitle: 'Häufig Gestellte Fragen',
        faq1Question: 'Was ist Google Veo 3.1?',
        faq1Answer:
            'Google Veo 3.1 ist das neueste KI-Videogenerierungsmodell, das von Google DeepMind entwickelt wurde, eine verbesserte Version von Veo 3. Es kann hochwertige, realistische Videoinhalte basierend auf Text-Prompts oder Referenzbildern generieren und unterstützt fortgeschrittene Funktionen wie Frame-zu-Video, Material-zu-Video und native Audiogenerierung.',
        faq2Question: 'Was ist der Unterschied zwischen Veo 3.1 und Veo 3?',
        faq2Answer:
            'Veo 3.1 ist eine erweiterte Version von Veo 3, mit wichtigen Verbesserungen einschließlich: stärkere Frame-zu-Video-Fähigkeiten, bessere Material-zu-Video-Effekte, intelligentere Szenenerweiterung, präziseres Prompt-Verständnis und höhere Videogenerierungsqualität. Veo 3.1 verbessert die kreative Flexibilität und Ausgabequalität weiter, während die Hauptvorteile von Veo 3 beibehalten werden.',
        faq3Question: 'Wie lange können von Veo 3.1 generierte Videos sein?',
        faq3Answer:
            'Veo 3.1 unterstützt die Generierung von Videos verschiedener Längen, abhängig von Ihrer gewählten Konfiguration und Plattformbeschränkungen. Auf der 微鲤AI-Plattform können Sie Videoinhalte von wenigen Sekunden bis zu mehreren Minuten generieren.',
        faq4Question: 'Wie verwende ich Veo 3.1 auf 微鲤AI?',
        faq4Answer:
            'Es ist sehr einfach: 1) Besuchen Sie die 微鲤AI-Plattform und wählen Sie das Veo 3.1-Modell; 2) Geben Sie Ihren Text-Prompt ein oder laden Sie ein Referenzbild hoch; 3) Klicken Sie auf den Generieren-Button und warten Sie auf die KI-Erstellung; 4) Laden Sie Ihr Video herunter oder teilen Sie es.',
        faq5Question: 'Enthalten von Veo 3.1 generierte Videos Wasserzeichen?',
        faq5Answer:
            'Dies hängt von Ihrem 微鲤AI-Abonnementplan ab. Von kostenlosen Benutzern generierte Videos können Wasserzeichen enthalten, während bezahlte Abonnenten hochwertige Videos ohne Wasserzeichen erhalten können.',
        faq6Question: 'Welche Sprachen unterstützt Veo 3.1 für Prompts?',
        faq6Answer:
            'Veo 3.1 unterstützt Prompts in mehreren Sprachen, einschließlich Chinesisch, Englisch, Japanisch, Koreanisch und anderen Hauptsprachen. Das KI-Modell kann kreative Beschreibungen in verschiedenen Sprachen genau verstehen und entsprechende Videoinhalte generieren.',
        faq7Question:
            'Kann ich mit Veo 3.1 generierte Videos kommerziell nutzen?',
        faq7Answer:
            'Kommerzielle Nutzungsrechte hängen von den Nutzungsbedingungen von 微鲤AI und Ihrem Abonnementplan ab. Wir empfehlen, die Nutzungsvereinbarung der Plattform vor kommerzieller Nutzung zu überprüfen oder den Kundenservice für detaillierte Lizenzinformationen zu kontaktieren.',

        // CTA-Abschnitt
        ctaTitle: 'Bereit zum Erstellen?',
        ctaSubtitle:
            'Testen Sie Veo 3.1 jetzt und verwandeln Sie Ihre Ideen in atemberaubende Videos',
        ctaDescription:
            'Erleben Sie die Leistungsfähigkeit von Veo 3.1 und verwandeln Sie Ihre kreativen Ideen in professionelle Videoinhalte.',
        ctaButton: 'Testen Sie Veo 3.1 auf 微鲤AI',
        ctaNote: 'Keine Kreditkarte erforderlich',

        // Videowiedergabe-bezogen
        videoNotSupported: 'Ihr Browser unterstützt keine Videowiedergabe',
        videoUnsupported: 'Ihr Browser unterstützt keine Videowiedergabe',
        videoLoadError: 'Videoladen fehlgeschlagen',
        videoReload: 'Neu laden',
    },
    ru: {
        // Заголовок и описание страницы
        pageTitle:
            'Генератор Видео ИИ Google Veo 3.1 - Бесплатный Продвинутый Инструмент Создания Видео ИИ',
        pageDescription:
            'Испытайте генератор видео ИИ Google Veo 3.1 с кадр в видео, материал в видео, генерацией нативного аудио и многим другим. Попробуйте бесплатно на платформе 微鲤AI для создания профессиональных ИИ-видео.',
        pageKeywords:
            'Veo 3.1, генератор видео ИИ Google, создание видео ИИ, видео искусственного интеллекта, инструмент генерации видео, бесплатное ИИ-видео, 微鲤AI, производство видео',

        // Раздел генератора
        generatorTitle: 'Генератор Видео ИИ Google Veo 3.1',
        generatorDescription:
            'Google Veo 3.1 - это самая передовая модель видео с ИИ, которая генерирует высококачественный, реалистичный аудиовизуальный контент. Это улучшенная версия Veo 3 со значительными улучшениями качества и функций. Попробуйте Veo 3.1 бесплатно на генераторе видео 微鲤AI!',

        // Вкладки
        tabImageToVideo: 'Изображение в видео',
        tabTextToVideo: 'Текст в видео',

        // Раздел основных функций
        coreFeaturesTitle: 'Основные функции Veo 3.1',
        coreFeaturesSubtitle:
            'Изучите основные возможности генератора видео ИИ Google Veo 3.1 и познакомьтесь с созданием видео с ИИ следующего поколения',

        // Функция кадр в видео
        frameToVideoTitle: 'Кадр в Видео (Контроль Первого и Последнего Кадра)',
        frameToVideoDescription:
            'Veo 3.1 поддерживает генерацию видео через контроль первого и последнего кадра, позволяя вам точно контролировать начальный и конечный кадры вашего видео для более связного визуального повествования.',
        frameToFrameTitle: 'Покадровый Контроль',
        frameToFrameDescription:
            'Контролируйте генерацию видео, указывая первый и последний кадр, создавая плавные переходы и связные визуальные повествования.',

        // Функция материал в видео
        materialToVideoTitle: 'Материал в Видео',
        materialToVideoDescription:
            'Создавайте высококачественные видео на основе существующих материалов и ссылок, обеспечивая интеллектуальное воссоздание и визуальное улучшение вашего контента.',

        // Функция генерации нативного аудио
        nativeAudioTitle: 'Генерация Нативного Аудио',
        nativeAudioDescription:
            'Veo 3.1 создает аудио и интегрирует его в сгенерированные видео, достигая идеальной аудиовизуальной синхронизации для более привлекательного и реалистичного контента.',

        // Функция последовательного персонажа
        consistentCharacterTitle: 'Последовательное Исполнение Персонажей',
        consistentCharacterDescription:
            'Гарантирует, что персонажи сохраняют высокую последовательность внешнего вида и характеристик в разных сценах и кадрах, создавая связный визуальный опыт.',

        // Функция расширенного промпта
        advancedPromptTitle: 'Расширенное Понимание Промптов',
        advancedPromptDescription:
            'Точно интерпретирует сложные промпты, точно понимает ваше творческое намерение и преобразует текстовые описания в живые визуальные сцены.',

        // Функция расширения сцен
        sceneExpansionTitle: 'Мощное Расширение Сцен',
        sceneExpansionDescription:
            'Интеллектуально расширяет видеосцены для генерации более богатого визуального контента, позволяя вашей креативности преодолевать ограничения времени и пространства.',

        // Раздел как использовать
        howToUseTitle: 'Как использовать',
        howToUseSubtitle: 'Начните Создавать в Три Простых Шага',
        step1Title: 'Выберите Модель',
        step1Description: 'Выберите модель Veo 3.1 в инструментах видео с ИИ',
        step2Title: 'Введите Содержимое',
        step2Description:
            'Введите текстовый промпт или загрузите референсное изображение',
        step3Title: 'Сгенерируйте Видео',
        step3Description:
            'Нажмите кнопку генерации, дождитесь и скачайте ваше видео',

        // Раздел видео на YouTube
        youtubeVideosTitle: 'Видео на YouTube о модели видео ИИ Google Veo 3.1',
        youtubeVideoTitle: 'Видео на YouTube о модели видео ИИ Google Veo 3.1',

        // Раздел постов X
        xPostsTitle: 'Посты X о модели видео ИИ Veo 3.1',

        // Раздел исследования других моделей
        exploreOtherModelsTitle: 'Исследовать Другие Модели Veo',
        veo2Title: 'Генератор видео ИИ Google Veo 2',
        veo3Title: 'Генератор видео ИИ Google Veo 3',
        veo3FastTitle: 'Генератор видео ИИ Google Veo 3 Fast',

        // Раздел FAQ
        faqTitle: 'Часто задаваемые вопросы',
        faq1Question: 'Что такое Google Veo 3.1?',
        faq1Answer:
            'Google Veo 3.1 - это новейшая модель генерации видео с ИИ, разработанная Google DeepMind, улучшенная версия Veo 3. Она может генерировать высококачественный, реалистичный видеоконтент на основе текстовых промптов или референсных изображений, поддерживая передовые функции, такие как кадр в видео, материал в видео и генерация нативного аудио.',
        faq2Question: 'В чем разница между Veo 3.1 и Veo 3?',
        faq2Answer:
            'Veo 3.1 - это расширенная версия Veo 3 с ключевыми улучшениями, включающими: более сильные возможности кадр в видео, лучшие эффекты материал в видео, более умное расширение сцен, более точное понимание промптов и более высокое качество генерации видео. Veo 3.1 дополнительно улучшает творческую гибкость и качество вывода, сохраняя основные преимущества Veo 3.',
        faq3Question: 'Какой длины видео может генерировать Veo 3.1?',
        faq3Answer:
            'Veo 3.1 поддерживает генерацию видео различной продолжительности, в зависимости от выбранной вами конфигурации и ограничений платформы. На платформе 微鲤AI вы можете генерировать видеоконтент продолжительностью от нескольких секунд до нескольких минут.',
        faq4Question: 'Как использовать Veo 3.1 на 微鲤AI?',
        faq4Answer:
            'Это очень просто: 1) Посетите платформу 微鲤AI и выберите модель Veo 3.1; 2) Введите ваш текстовый промпт или загрузите референсное изображение; 3) Нажмите кнопку генерации и дождитесь создания ИИ; 4) Скачайте или поделитесь вашим видео.',
        faq5Question:
            'Содержат ли видео, сгенерированные Veo 3.1, водяные знаки?',
        faq5Answer:
            'Это зависит от вашего плана подписки 微鲤AI. Видео, сгенерированные бесплатными пользователями, могут содержать водяные знаки, в то время как платные подписчики могут получать высококачественные видео без водяных знаков.',
        faq6Question: 'Какие языки поддерживает Veo 3.1 для промптов?',
        faq6Answer:
            'Veo 3.1 поддерживает промпты на нескольких языках, включая китайский, английский, японский, корейский и другие основные языки. Модель ИИ может точно понимать творческие описания на разных языках и генерировать соответствующий видеоконтент.',
        faq7Question:
            'Могу ли я использовать видео, сгенерированные Veo 3.1, в коммерческих целях?',
        faq7Answer:
            'Права коммерческого использования зависят от условий обслуживания 微鲤AI и вашего плана подписки. Мы рекомендуем ознакомиться с соглашением об использовании платформы перед коммерческим использованием или связаться со службой поддержки для получения подробной информации о лицензировании.',

        // Раздел CTA
        ctaTitle: 'Готовы начать создавать?',
        ctaSubtitle:
            'Попробуйте Veo 3.1 сейчас и превратите свои идеи в потрясающие видео',
        ctaDescription:
            'Испытайте мощь Veo 3.1 и превратите свои творческие идеи в профессиональный видеоконтент.',
        ctaButton: 'Попробуйте Veo 3.1 на 微鲤AI',
        ctaNote: 'Кредитная карта не требуется',

        // Связанное с воспроизведением видео
        videoNotSupported: 'Ваш браузер не поддерживает воспроизведение видео',
        videoUnsupported: 'Ваш браузер не поддерживает воспроизведение видео',
        videoLoadError: 'Ошибка загрузки видео',
        videoReload: 'Перезагрузить',
    },
    pt: {
        // Título e descrição da página
        pageTitle:
            'Gerador de Vídeo IA Google Veo 3.1 - Ferramenta Avançada de Criação de Vídeo IA Grátis',
        pageDescription:
            'Experimente o gerador de vídeo IA Google Veo 3.1 com quadro a vídeo, material para vídeo, geração de áudio nativo e mais. Experimente grátis na plataforma 微鲤AI para criar vídeos IA profissionais.',
        pageKeywords:
            'Veo 3.1, gerador de vídeo IA Google, criação de vídeo IA, vídeo inteligência artificial, ferramenta geração vídeo, vídeo IA grátis, 微鲤AI, produção de vídeo',

        // Seção do gerador
        generatorTitle: 'Gerador de Vídeo IA Google Veo 3.1',
        generatorDescription:
            'Google Veo 3.1 é o modelo de vídeo IA mais avançado que gera conteúdo audiovisual de alta qualidade e realista. É uma versão melhorada do Veo 3 com melhorias significativas em qualidade e recursos. Experimente Veo 3.1 gratuitamente no gerador de vídeo 微鲤AI!',

        // Abas
        tabImageToVideo: 'Imagem para Vídeo',
        tabTextToVideo: 'Texto para Vídeo',

        // Seção de recursos principais
        coreFeaturesTitle: 'Recursos Principais do Veo 3.1',
        coreFeaturesSubtitle:
            'Explore as capacidades principais do gerador de vídeo IA Google Veo 3.1 e experimente a criação de vídeo IA de próxima geração',

        // Função quadro a vídeo
        frameToVideoTitle:
            'Quadro a Vídeo (Controle do Primeiro e Último Quadro)',
        frameToVideoDescription:
            'Veo 3.1 suporta geração de vídeo através do controle do primeiro e último quadro, permitindo que você controle com precisão os quadros inicial e final do seu vídeo para uma narrativa visual mais coerente.',
        frameToFrameTitle: 'Controle Quadro a Quadro',
        frameToFrameDescription:
            'Controle a geração de vídeo especificando o primeiro e último quadro, criando transições suaves e narrativas visuais coerentes.',

        // Função material para vídeo
        materialToVideoTitle: 'Material para Vídeo',
        materialToVideoDescription:
            'Crie vídeos de alta qualidade baseados em materiais e referências existentes, permitindo recriação inteligente e aprimoramento visual do seu conteúdo.',

        // Função de geração de áudio nativo
        nativeAudioTitle: 'Geração de Áudio Nativo',
        nativeAudioDescription:
            'Veo 3.1 cria áudio e o integra em vídeos gerados, alcançando sincronização audiovisual perfeita para conteúdo mais envolvente e realista.',

        // Função personagem consistente
        consistentCharacterTitle: 'Performance de Personagem Consistente',
        consistentCharacterDescription:
            'Garante que os personagens mantenham aparência e características altamente consistentes em diferentes cenas e tomadas, criando uma experiência visual coerente.',

        // Função prompt avançado
        advancedPromptTitle: 'Compreensão Avançada de Prompts',
        advancedPromptDescription:
            'Interpreta com precisão prompts complexos, compreende exatamente sua intenção criativa e transforma descrições de texto em cenas visuais vívidas.',

        // Função de expansão de cena
        sceneExpansionTitle: 'Expansão de Cena Poderosa',
        sceneExpansionDescription:
            'Expande inteligentemente as cenas de vídeo para gerar conteúdo visual mais rico, permitindo que sua criatividade rompa as limitações de tempo e espaço.',

        // Seção como usar
        howToUseTitle: 'Como Usar',
        howToUseSubtitle: 'Comece a Criar em Três Passos Simples',
        step1Title: 'Selecionar Modelo',
        step1Description:
            'Escolha o modelo Veo 3.1 nas ferramentas de vídeo IA',
        step2Title: 'Inserir Conteúdo',
        step2Description:
            'Digite prompt de texto ou carregue imagem de referência',
        step3Title: 'Gerar Vídeo',
        step3Description: 'Clique no botão gerar, aguarde e baixe seu vídeo',

        // Seção de vídeos do YouTube
        youtubeVideosTitle:
            'Vídeos do YouTube sobre o Modelo de Vídeo IA Google Veo 3.1',
        youtubeVideoTitle:
            'Vídeos do YouTube sobre o Modelo de Vídeo IA Google Veo 3.1',

        // Seção de publicações X
        xPostsTitle: 'Publicações X sobre o Modelo de Vídeo IA Veo 3.1',

        // Seção explorar outros modelos
        exploreOtherModelsTitle: 'Explorar Outros Modelos Veo',
        veo2Title: 'Gerador de Vídeo IA Google Veo 2',
        veo3Title: 'Gerador de Vídeo IA Google Veo 3',
        veo3FastTitle: 'Gerador de Vídeo IA Google Veo 3 Fast',

        // Seção FAQ
        faqTitle: 'Perguntas Frequentes',
        faq1Question: 'O que é Google Veo 3.1?',
        faq1Answer:
            'Google Veo 3.1 é o mais recente modelo de geração de vídeo IA desenvolvido pelo Google DeepMind, uma versão melhorada do Veo 3. Pode gerar conteúdo de vídeo de alta qualidade e realista baseado em prompts de texto ou imagens de referência, suportando recursos avançados como quadro a vídeo, material para vídeo e geração de áudio nativo.',
        faq2Question: 'Qual é a diferença entre Veo 3.1 e Veo 3?',
        faq2Answer:
            'Veo 3.1 é uma versão aprimorada do Veo 3, com melhorias chave incluindo: capacidades mais fortes de quadro a vídeo, melhores efeitos de material para vídeo, expansão de cena mais inteligente, compreensão de prompts mais precisa e maior qualidade de geração de vídeo. Veo 3.1 aprimora ainda mais a flexibilidade criativa e a qualidade de saída enquanto mantém as vantagens principais do Veo 3.',
        faq3Question: 'Quanto tempo podem ter os vídeos gerados pelo Veo 3.1?',
        faq3Answer:
            'Veo 3.1 suporta a geração de vídeos de várias durações, dependendo da sua configuração escolhida e limitações da plataforma. Na plataforma 微鲤AI, você pode gerar conteúdo de vídeo que varia de alguns segundos a vários minutos.',
        faq4Question: 'Como uso o Veo 3.1 no 微鲤AI?',
        faq4Answer:
            'É muito simples: 1) Visite a plataforma 微鲤AI e selecione o modelo Veo 3.1; 2) Digite seu prompt de texto ou carregue imagem de referência; 3) Clique no botão gerar e aguarde a criação da IA; 4) Baixe ou compartilhe seu vídeo.',
        faq5Question: "Os vídeos gerados pelo Veo 3.1 contêm marcas d'água?",
        faq5Answer:
            "Isso depende do seu plano de assinatura 微鲤AI. Vídeos gerados por usuários gratuitos podem conter marcas d'água, enquanto assinantes pagos podem obter vídeos de alta qualidade sem marcas d'água.",
        faq6Question: 'Quais idiomas o Veo 3.1 suporta para prompts?',
        faq6Answer:
            'Veo 3.1 suporta prompts em vários idiomas, incluindo chinês, inglês, japonês, coreano e outros idiomas principais. O modelo IA pode compreender com precisão descrições criativas em diferentes idiomas e gerar conteúdo de vídeo correspondente.',
        faq7Question: 'Posso usar vídeos gerados pelo Veo 3.1 comercialmente?',
        faq7Answer:
            'Os direitos de uso comercial dependem dos termos de serviço do 微鲤AI e do seu plano de assinatura. Recomendamos verificar o acordo de uso da plataforma antes do uso comercial, ou entrar em contato com o atendimento ao cliente para informações detalhadas de licenciamento.',

        // Seção CTA
        ctaTitle: 'Pronto para Começar a Criar?',
        ctaSubtitle:
            'Experimente o Veo 3.1 agora e transforme suas ideias em vídeos impressionantes',
        ctaDescription:
            'Experimente o poder do Veo 3.1 e transforme suas ideias criativas em conteúdo de vídeo profissional.',
        ctaButton: 'Experimente o Veo 3.1 no 微鲤AI',
        ctaNote: 'Não é necessário cartão de crédito',

        // Relacionado à reprodução de vídeo
        videoNotSupported: 'Seu navegador não suporta reprodução de vídeo',
        videoUnsupported: 'Seu navegador não suporta reprodução de vídeo',
        videoLoadError: 'Falha ao carregar o vídeo',
        videoReload: 'Recarregar',
    },
    it: {
        // Titolo e descrizione della pagina
        pageTitle:
            'Generatore Video IA Google Veo 3.1 - Strumento Avanzato di Creazione Video IA Gratis',
        pageDescription:
            'Sperimenta il generatore video IA Google Veo 3.1 con fotogramma a video, materiale a video, generazione audio nativa e altro. Provalo gratis sulla piattaforma 微鲤AI per creare video IA professionali.',
        pageKeywords:
            'Veo 3.1, generatore video IA Google, creazione video IA, video intelligenza artificiale, strumento generazione video, video IA gratuito, 微鲤AI, produzione video',

        // Sezione generatore
        generatorTitle: 'Generatore Video IA Google Veo 3.1',
        generatorDescription:
            'Google Veo 3.1 è il modello video IA più avanzato che genera contenuti audiovisivi di alta qualità e realistici. È una versione migliorata di Veo 3 con miglioramenti significativi in qualità e funzionalità. Prova Veo 3.1 gratuitamente sul generatore video 微鲤AI!',

        // Schede
        tabImageToVideo: 'Immagine a Video',
        tabTextToVideo: 'Testo a Video',

        // Sezione caratteristiche principali
        coreFeaturesTitle: 'Caratteristiche Principali di Veo 3.1',
        coreFeaturesSubtitle:
            'Esplora le capacità principali del generatore video IA Google Veo 3.1 e sperimenta la creazione video IA di nuova generazione',

        // Funzione fotogramma a video
        frameToVideoTitle:
            'Fotogramma a Video (Controllo del Primo e Ultimo Fotogramma)',
        frameToVideoDescription:
            'Veo 3.1 supporta la generazione video tramite controllo del primo e ultimo fotogramma, permettendoti di controllare con precisione i fotogrammi iniziale e finale del tuo video per una narrazione visiva più coerente.',
        frameToFrameTitle: 'Controllo Fotogramma per Fotogramma',
        frameToFrameDescription:
            "Controlla la generazione video specificando il primo e l'ultimo fotogramma, creando transizioni fluide e narrazioni visive coerenti.",

        // Funzione materiale a video
        materialToVideoTitle: 'Materiale a Video',
        materialToVideoDescription:
            'Crea video di alta qualità basati su materiali e riferimenti esistenti, abilitando ricreazione intelligente e miglioramento visivo del tuo contenuto.',

        // Funzione generazione audio nativa
        nativeAudioTitle: 'Generazione Audio Nativa',
        nativeAudioDescription:
            'Veo 3.1 crea audio e lo integra nei video generati, ottenendo una sincronizzazione audiovisiva perfetta per contenuti più coinvolgenti e realistici.',

        // Funzione personaggio coerente
        consistentCharacterTitle: 'Performance del Personaggio Coerente',
        consistentCharacterDescription:
            "Assicura che i personaggi mantengano aspetto e caratteristiche altamente coerenti attraverso scene e inquadrature diverse, creando un'esperienza visiva coerente.",

        // Funzione prompt avanzato
        advancedPromptTitle: 'Comprensione Avanzata dei Prompt',
        advancedPromptDescription:
            'Interpreta con precisione prompt complessi, comprende esattamente la tua intenzione creativa e trasforma descrizioni testuali in scene visive vivide.',

        // Funzione espansione scena
        sceneExpansionTitle: 'Espansione Scena Potente',
        sceneExpansionDescription:
            'Espande intelligentemente le scene video per generare contenuti visivi più ricchi, permettendo alla tua creatività di superare i limiti di tempo e spazio.',

        // Sezione come usare
        howToUseTitle: 'Come Usare',
        howToUseSubtitle: 'Inizia a Creare in Tre Semplici Passaggi',
        step1Title: 'Seleziona Modello',
        step1Description: 'Scegli il modello Veo 3.1 negli strumenti video IA',
        step2Title: 'Inserisci Contenuto',
        step2Description:
            'Inserisci prompt di testo o carica immagine di riferimento',
        step3Title: 'Genera Video',
        step3Description:
            'Clicca sul pulsante genera, attendi e scarica il tuo video',

        // Sezione video YouTube
        youtubeVideosTitle: 'Video YouTube sul Modello Video IA Google Veo 3.1',
        youtubeVideoTitle: 'Video YouTube sul Modello Video IA Google Veo 3.1',

        // Sezione post X
        xPostsTitle: 'Post X sul Modello Video IA Veo 3.1',

        // Sezione esplora altri modelli
        exploreOtherModelsTitle: 'Esplora Altri Modelli Veo',
        veo2Title: 'Generatore Video IA Google Veo 2',
        veo3Title: 'Generatore Video IA Google Veo 3',
        veo3FastTitle: 'Generatore Video IA Google Veo 3 Fast',

        // Sezione FAQ
        faqTitle: 'Domande Frequenti',
        faq1Question: "Cos'è Google Veo 3.1?",
        faq1Answer:
            "Google Veo 3.1 è l'ultimo modello di generazione video IA sviluppato da Google DeepMind, una versione migliorata di Veo 3. Può generare contenuti video di alta qualità e realistici basati su prompt di testo o immagini di riferimento, supportando funzionalità avanzate come fotogramma a video, materiale a video e generazione audio nativa.",
        faq2Question: 'Qual è la differenza tra Veo 3.1 e Veo 3?',
        faq2Answer:
            "Veo 3.1 è una versione potenziata di Veo 3, con miglioramenti chiave tra cui: capacità più forti di fotogramma a video, migliori effetti materiale a video, espansione scena più intelligente, comprensione prompt più precisa e qualità di generazione video superiore. Veo 3.1 migliora ulteriormente la flessibilità creativa e la qualità dell'output mantenendo i principali vantaggi di Veo 3.",
        faq3Question: 'Quanto possono durare i video generati da Veo 3.1?',
        faq3Answer:
            'Veo 3.1 supporta la generazione di video di varie lunghezze, a seconda della configurazione scelta e delle limitazioni della piattaforma. Sulla piattaforma 微鲤AI, puoi generare contenuti video che vanno da pochi secondi a diversi minuti.',
        faq4Question: 'Come uso Veo 3.1 su 微鲤AI?',
        faq4Answer:
            "È molto semplice: 1) Visita la piattaforma 微鲤AI e seleziona il modello Veo 3.1; 2) Inserisci il tuo prompt di testo o carica un'immagine di riferimento; 3) Clicca sul pulsante genera e attendi la creazione IA; 4) Scarica o condividi il tuo video.",
        faq5Question: 'I video generati da Veo 3.1 contengono filigrane?',
        faq5Answer:
            'Questo dipende dal tuo piano di abbonamento 微鲤AI. I video generati da utenti gratuiti possono contenere filigrane, mentre gli abbonati paganti possono ottenere video di alta qualità senza filigrane.',
        faq6Question: 'Quali lingue supporta Veo 3.1 per i prompt?',
        faq6Answer:
            'Veo 3.1 supporta prompt in più lingue, tra cui cinese, inglese, giapponese, coreano e altre lingue principali. Il modello IA può comprendere accuratamente descrizioni creative in lingue diverse e generare contenuti video corrispondenti.',
        faq7Question:
            'Posso usare commercialmente i video generati da Veo 3.1?',
        faq7Answer:
            "I diritti di uso commerciale dipendono dai termini di servizio di 微鲤AI e dal tuo piano di abbonamento. Consigliamo di verificare l'accordo d'uso della piattaforma prima dell'uso commerciale, o di contattare il servizio clienti per informazioni dettagliate sulla licenza.",

        // Sezione CTA
        ctaTitle: 'Pronto per Iniziare a Creare?',
        ctaSubtitle:
            'Prova Veo 3.1 ora e trasforma le tue idee in video straordinari',
        ctaDescription:
            'Sperimenta la potenza di Veo 3.1 e trasforma le tue idee creative in contenuti video professionali.',
        ctaButton: 'Prova Veo 3.1 su 微鲤AI',
        ctaNote: 'Non è richiesta la carta di credito',

        // Relativo alla riproduzione video
        videoNotSupported: 'Il tuo browser non supporta la riproduzione video',
        videoUnsupported: 'Il tuo browser non supporta la riproduzione video',
        videoLoadError: 'Caricamento video fallito',
        videoReload: 'Ricarica',
    },
    ar: {
        // عنوان ووصف الصفحة
        pageTitle:
            'مولد فيديو الذكاء الاصطناعي Google Veo 3.1 - أداة إنشاء فيديو متقدمة بالذكاء الاصطناعي مجانية',
        pageDescription:
            'جرب مولد فيديو الذكاء الاصطناعي Google Veo 3.1 مع الإطار إلى فيديو والمواد إلى فيديو وتوليد الصوت الأصلي والمزيد. جربه مجانًا على منصة 微鲤AI لإنشاء مقاطع فيديو ذكاء اصطناعي احترافية.',
        pageKeywords:
            'Veo 3.1, مولد فيديو ذكاء اصطناعي من Google, إنشاء فيديو بالذكاء الاصطناعي, فيديو الذكاء الاصطناعي, أداة توليد الفيديو, فيديو ذكاء اصطناعي مجاني, 微鲤AI, إنتاج الفيديو',

        // قسم المولد
        generatorTitle: 'مولد الفيديو بالذكاء الاصطناعي Google Veo 3.1',
        generatorDescription:
            'Google Veo 3.1 هو نموذج الفيديو بالذكاء الاصطناعي الأكثر تقدمًا الذي يولد محتوى سمعي بصري عالي الجودة وواقعي. إنها نسخة محسّنة من Veo 3 مع تحسينات كبيرة في الجودة والميزات. جرب Veo 3.1 مجانًا على مولد الفيديو 微鲤AI!',

        // التبويبات
        tabImageToVideo: 'صورة إلى فيديو',
        tabTextToVideo: 'نص إلى فيديو',

        // قسم الميزات الأساسية
        coreFeaturesTitle: 'الميزات الرئيسية لـ Veo 3.1',
        coreFeaturesSubtitle:
            'استكشف القدرات الأساسية لمولد الفيديو بالذكاء الاصطناعي Google Veo 3.1 واختبر إنشاء فيديو بالذكاء الاصطناعي من الجيل التالي',

        // وظيفة إطار إلى فيديو
        frameToVideoTitle: 'إطار إلى فيديو (التحكم في الإطار الأول والأخير)',
        frameToVideoDescription:
            'يدعم Veo 3.1 توليد الفيديو من خلال التحكم في الإطار الأول والأخير، مما يتيح لك التحكم بدقة في إطارات البداية والنهاية لفيديوك للحصول على سرد بصري أكثر تماسكًا.',
        frameToFrameTitle: 'التحكم إطار بإطار',
        frameToFrameDescription:
            'تحكم في توليد الفيديو من خلال تحديد الإطار الأول والأخير، مما يخلق انتقالات سلسة وسرديات بصرية متماسكة.',

        // وظيفة مواد إلى فيديو
        materialToVideoTitle: 'مواد إلى فيديو',
        materialToVideoDescription:
            'أنشئ مقاطع فيديو عالية الجودة بناءً على المواد والمراجع الحالية، مما يمكّن من إعادة الإنشاء الذكي والتحسين البصري لمحتواك.',

        // وظيفة توليد الصوت الأصلي
        nativeAudioTitle: 'توليد الصوت الأصلي',
        nativeAudioDescription:
            'يُنشئ Veo 3.1 الصوت ويدمجه في مقاطع الفيديو المُنشأة، محققًا مزامنة سمعية بصرية مثالية لمحتوى أكثر جاذبية وواقعية.',

        // وظيفة شخصية متسقة
        consistentCharacterTitle: 'أداء شخصية متسق',
        consistentCharacterDescription:
            'يضمن أن الشخصيات تحافظ على مظهر وخصائص متسقة للغاية عبر مشاهد ولقطات مختلفة، مما يخلق تجربة بصرية متماسكة.',

        // وظيفة مطالبة متقدمة
        advancedPromptTitle: 'فهم متقدم للمطالبات',
        advancedPromptDescription:
            'يفسر بدقة المطالبات المعقدة، ويفهم بالضبط نيتك الإبداعية ويحول الأوصاف النصية إلى مشاهد بصرية حية.',

        // وظيفة توسيع المشهد
        sceneExpansionTitle: 'توسيع مشهد قوي',
        sceneExpansionDescription:
            'يوسع بذكاء مشاهد الفيديو لتوليد محتوى بصري أكثر ثراءً، مما يسمح لإبداعك بكسر قيود الزمان والمكان.',

        // قسم كيفية الاستخدام
        howToUseTitle: 'كيفية الاستخدام',
        howToUseSubtitle: 'ابدأ الإنشاء في ثلاث خطوات بسيطة',
        step1Title: 'اختر النموذج',
        step1Description:
            'اختر نموذج Veo 3.1 في أدوات الفيديو بالذكاء الاصطناعي',
        step2Title: 'أدخل المحتوى',
        step2Description: 'أدخل مطالبة نصية أو قم بتحميل صورة مرجعية',
        step3Title: 'أنشئ الفيديو',
        step3Description:
            'انقر فوق زر الإنشاء، انتظر وقم بتنزيل الفيديو الخاص بك',

        // قسم فيديوهات YouTube
        youtubeVideosTitle:
            'فيديوهات YouTube حول نموذج الفيديو بالذكاء الاصطناعي Google Veo 3.1',
        youtubeVideoTitle:
            'فيديوهات YouTube حول نموذج الفيديو بالذكاء الاصطناعي Google Veo 3.1',

        // قسم منشورات X
        xPostsTitle: 'منشورات X حول نموذج الفيديو بالذكاء الاصطناعي Veo 3.1',

        // قسم استكشاف نماذج أخرى
        exploreOtherModelsTitle: 'استكشف نماذج Veo الأخرى',
        veo2Title: 'مولد الفيديو بالذكاء الاصطناعي Google Veo 2',
        veo3Title: 'مولد الفيديو بالذكاء الاصطناعي Google Veo 3',
        veo3FastTitle: 'مولد الفيديو بالذكاء الاصطناعي Google Veo 3 Fast',

        // قسم الأسئلة الشائعة
        faqTitle: 'الأسئلة الشائعة',
        faq1Question: 'ما هو Google Veo 3.1؟',
        faq1Answer:
            'Google Veo 3.1 هو أحدث نموذج توليد فيديو بالذكاء الاصطناعي طورته Google DeepMind، نسخة محسّنة من Veo 3. يمكنه توليد محتوى فيديو عالي الجودة وواقعي بناءً على مطالبات نصية أو صور مرجعية، ويدعم ميزات متقدمة مثل الإطار إلى فيديو والمواد إلى فيديو وتوليد الصوت الأصلي.',
        faq2Question: 'ما الفرق بين Veo 3.1 و Veo 3؟',
        faq2Answer:
            'Veo 3.1 هي نسخة محسّنة من Veo 3، مع تحسينات رئيسية تشمل: قدرات أقوى للإطار إلى فيديو، تأثيرات أفضل للمواد إلى فيديو، توسيع مشهد أكثر ذكاءً، فهم أكثر دقة للمطالبات وجودة أعلى لتوليد الفيديو. يعزز Veo 3.1 المرونة الإبداعية وجودة الإخراج بشكل أكبر مع الحفاظ على المزايا الرئيسية لـ Veo 3.',
        faq3Question:
            'ما المدة التي يمكن أن تصل إليها مقاطع الفيديو التي يولدها Veo 3.1؟',
        faq3Answer:
            'يدعم Veo 3.1 توليد مقاطع فيديو بأطوال مختلفة، اعتمادًا على التكوين الذي اخترته وقيود المنصة. على منصة 微鲤AI، يمكنك توليد محتوى فيديو يتراوح من بضع ثوانٍ إلى عدة دقائق.',
        faq4Question: 'كيف أستخدم Veo 3.1 على 微鲤AI؟',
        faq4Answer:
            'الأمر بسيط جدًا: 1) قم بزيارة منصة 微鲤AI واختر نموذج Veo 3.1؛ 2) أدخل مطالبتك النصية أو قم بتحميل صورة مرجعية؛ 3) انقر فوق زر الإنشاء وانتظر إنشاء الذكاء الاصطناعي؛ 4) قم بتنزيل أو مشاركة الفيديو الخاص بك.',
        faq5Question:
            'هل تحتوي مقاطع الفيديو التي يولدها Veo 3.1 على علامات مائية؟',
        faq5Answer:
            'يعتمد هذا على خطة اشتراكك في 微鲤AI. قد تحتوي مقاطع الفيديو التي يولدها المستخدمون المجانيون على علامات مائية، بينما يمكن للمشتركين المدفوعين الحصول على مقاطع فيديو عالية الجودة بدون علامات مائية.',
        faq6Question: 'ما اللغات التي يدعمها Veo 3.1 للمطالبات؟',
        faq6Answer:
            'يدعم Veo 3.1 المطالبات بلغات متعددة، بما في ذلك الصينية والإنجليزية واليابانية والكورية واللغات الرئيسية الأخرى. يمكن لنموذج الذكاء الاصطناعي فهم الأوصاف الإبداعية بلغات مختلفة بدقة وتوليد محتوى الفيديو المقابل.',
        faq7Question:
            'هل يمكنني استخدام مقاطع الفيديو التي يولدها Veo 3.1 تجاريًا؟',
        faq7Answer:
            'تعتمد حقوق الاستخدام التجاري على شروط خدمة 微鲤AI وخطة اشتراكك. نوصي بمراجعة اتفاقية استخدام المنصة قبل الاستخدام التجاري، أو الاتصال بخدمة العملاء للحصول على معلومات تفصيلية حول الترخيص.',

        // قسم CTA
        ctaTitle: 'هل أنت مستعد للبدء في الإنشاء؟',
        ctaSubtitle: 'جرب Veo 3.1 الآن وحوّل أفكارك إلى مقاطع فيديو مذهلة',
        ctaDescription:
            'اختبر قوة Veo 3.1 وحوّل أفكارك الإبداعية إلى محتوى فيديو احترافي.',
        ctaButton: 'جرب Veo 3.1 على 微鲤AI',
        ctaNote: 'لا حاجة لبطاقة ائتمان',

        // متعلق بتشغيل الفيديو
        videoNotSupported: 'متصفحك لا يدعم تشغيل الفيديو',
        videoUnsupported: 'متصفحك لا يدعم تشغيل الفيديو',
        videoLoadError: 'فشل تحميل الفيديو',
        videoReload: 'إعادة التحميل',
        },
    th: {
        // Page title and description
        pageTitle:
            'Google Veo 3.1 | โมเดลสร้างวิดีโอ AI ขั้นสูง | 微鲤AI',
        pageDescription:
            'Google Veo 3.1 สร้างวิดีโอคุณภาพสูงสมจริงด้วยการควบคุมเฟรม วัสดุเป็นวิดีโอ เสียงเนทีฟ การขยายฉาก และความเข้าใจพรอมต์อย่างแม่นยำ ทดลองฟรีบน 微鲤AI',
        pageKeywords:
            'Veo 3.1, Google Veo, เครื่องมือสร้างวิดีโอ AI, โมเดลวิดีโอขั้นสูง, ข้อความเป็นวิดีโอ, การสร้างวิดีโอ AI, 微鲤AI Veo 3.1',

        // Generator section
        generatorTitle: 'เครื่องมือสร้างวิดีโอ AI Google Veo 3.1',
        generatorDescription:
            'Google Veo 3.1 คือโมเดลวิดีโอ AI ขั้นสูงที่สุดที่สร้างคอนเทนต์ภาพและเสียงคุณภาพสูงสมจริง เป็นเวอร์ชันอัปเกรดจาก Veo 3 พร้อมการปรับปรุงคุณภาพและฟีเจอร์อย่างมาก ลอง Veo 3.1 ฟรีบนเครื่องมือสร้างวิดีโอ 微鲤AI!',

        // Tabs
        tabImageToVideo: 'ภาพเป็นวิดีโอ',
        tabTextToVideo: 'ข้อความเป็นวิดีโอ',

        // Core features section
        coreFeaturesTitle: 'ฟีเจอร์หลักของ Veo 3.1',
        coreFeaturesSubtitle:
            'สำรวจความสามารถหลักของเครื่องมือสร้างวิดีโอ AI Google Veo 3.1 และสัมผัสการสร้างวิดีโอ AI เจเนอเรชันถัดไป',

        // Frame to video feature
        frameToVideoTitle: 'เฟรมเป็นวิดีโอ (ควบคุมเฟรมแรกและเฟรมสุดท้าย)',
        frameToVideoDescription:
            'Veo 3.1 รองรับการสร้างวิดีโอด้วยการควบคุมเฟรมแรกและเฟรมสุดท้าย ทำให้คุณกำหนดจุดเริ่มและจบของวิดีโอได้อย่างแม่นยำเพื่อการเล่าเรื่องที่ต่อเนื่อง',
        frameToFrameTitle: 'ควบคุมเฟรม-ต่อ-เฟรม',
        frameToFrameDescription:
            'ควบคุมการสร้างวิดีโอด้วยการระบุเฟรมแรกและเฟรมสุดท้าย เพื่อการเปลี่ยนฉากที่ลื่นไหลและการเล่าเรื่องที่สอดคล้อง',

        // Material to video feature
        materialToVideoTitle: 'วัสดุเป็นวิดีโอ',
        materialToVideoDescription:
            'สร้างวิดีโอคุณภาพสูงจากวัสดุและอ้างอิงที่มีอยู่ ช่วยให้การสร้างซ้ำอย่างชาญฉลาดและเพิ่มคุณภาพภาพให้คอนเทนต์ของคุณ',

        // Native audio generation feature
        nativeAudioTitle: 'การสร้างเสียงเนทีฟ',
        nativeAudioDescription:
            'Veo 3.1 สร้างเสียงและผสานเข้ากับวิดีโอที่สร้างขึ้น เพื่อซิงก์เสียง-ภาพอย่างสมบูรณ์ ทำให้คอนเทนต์น่าดึงดูดและสมจริงขึ้น',

        // Consistent character feature
        consistentCharacterTitle: 'การแสดงตัวละครที่สม่ำเสมอ',
        consistentCharacterDescription:
            'ทำให้ตัวละครมีรูปลักษณ์และคุณลักษณะสอดคล้องกันในทุกฉากและช็อต สร้างประสบการณ์ภาพที่ต่อเนื่อง',

        // Advanced prompt feature
        advancedPromptTitle: 'ความเข้าใจพรอมต์ขั้นสูง',
        advancedPromptDescription:
            'ตีความพรอมต์ซับซ้อนได้อย่างแม่นยำ เข้าใจเจตนาสร้างสรรค์ และแปลงคำอธิบายเป็นฉากภาพที่มีชีวิตชีวา',

        // Scene expansion feature
        sceneExpansionTitle: 'การขยายฉากที่ทรงพลัง',
        sceneExpansionDescription:
            'ขยายฉากวิดีโออย่างชาญฉลาดเพื่อสร้างคอนเทนต์ภาพที่สมบูรณ์ยิ่งขึ้น ทำให้ความคิดสร้างสรรค์ก้าวข้ามข้อจำกัดด้านเวลาและพื้นที่',

        // How to use section
        howToUseTitle: 'วิธีใช้งาน',
        howToUseSubtitle: 'เริ่มสร้างได้ใน 3 ขั้นตอนง่าย ๆ',
        step1Title: 'เลือกโมเดล',
        step1Description: 'เลือกโมเดล Veo 3.1 ในเครื่องมือวิดีโอ AI',
        step2Title: 'ป้อนเนื้อหา',
        step2Description: 'พิมพ์พรอมต์ข้อความหรืออัปโหลดภาพอ้างอิง',
        step3Title: 'สร้างวิดีโอ',
        step3Description: 'คลิกปุ่มสร้าง รอ แล้วดาวน์โหลดวิดีโอของคุณ',

        // YouTube videos section
        youtubeVideosTitle:
            'วิดีโอ YouTube เกี่ยวกับโมเดลวิดีโอ AI Google Veo 3.1',
        youtubeVideoTitle:
            'วิดีโอ YouTube เกี่ยวกับโมเดลวิดีโอ AI Google Veo 3.1',

        // X Posts section
        xPostsTitle: 'โพสต์บน X เกี่ยวกับโมเดลวิดีโอ AI Veo 3.1',

        // Explore other models section
        exploreOtherModelsTitle: 'สำรวจโมเดล Veo อื่น ๆ',
        veo2Title: 'เครื่องมือสร้างวิดีโอ AI Google Veo 2',
        veo3Title: 'เครื่องมือสร้างวิดีโอ AI Google Veo 3',
        veo3FastTitle: 'เครื่องมือสร้างวิดีโอ AI Google Veo 3 Fast',

        // FAQ section
        faqTitle: 'คำถามที่พบบ่อย',
        faq1Question: 'Google Veo 3.1 คืออะไร?',
        faq1Answer:
            'Google Veo 3.1 คือโมเดลสร้างวิดีโอ AI รุ่นล่าสุดจาก Google DeepMind เป็นเวอร์ชันอัปเกรดจาก Veo 3 สร้างวิดีโอคุณภาพสูงสมจริงจากพรอมต์ข้อความหรือภาพอ้างอิง พร้อมฟีเจอร์ขั้นสูงอย่างเฟรมเป็นวิดีโอ วัสดุเป็นวิดีโอ และการสร้างเสียงเนทีฟ',
        faq2Question: 'Veo 3.1 ต่างจาก Veo 3 อย่างไร?',
        faq2Answer:
            'Veo 3.1 เป็นเวอร์ชันที่ยกระดับจาก Veo 3 โดยมีการปรับปรุงสำคัญ เช่น ความสามารถเฟรมเป็นวิดีโอที่แข็งแกร่งขึ้น เอฟเฟกต์วัสดุเป็นวิดีโอที่ดีขึ้น การขยายฉากที่ฉลาดขึ้น ความเข้าใจพรอมต์ที่แม่นยำขึ้น และคุณภาพวิดีโอที่สูงขึ้น ทั้งยังคงจุดเด่นเดิมของ Veo 3',
        faq3Question: 'Veo 3.1 สร้างวิดีโอยาวเท่าไรได้บ้าง?',
        faq3Answer:
            'Veo 3.1 รองรับการสร้างวิดีโอได้หลายความยาว ขึ้นอยู่กับการตั้งค่าและข้อจำกัดของแพลตฟอร์ม บน 微鲤AI สามารถสร้างวิดีโอได้ตั้งแต่ไม่กี่วินาทีจนถึงหลายนาที',
        faq4Question: 'ฉันใช้ Veo 3.1 บน 微鲤AI อย่างไร?',
        faq4Answer:
            'ทำได้ง่ายมาก: 1) เข้าแพลตฟอร์ม 微鲤AI และเลือกโมเดล Veo 3.1; 2) พิมพ์พรอมต์หรืออัปโหลดภาพอ้างอิง; 3) คลิกปุ่มสร้างและรอให้ AI ทำงาน; 4) ดาวน์โหลดหรือแชร์วิดีโอ',
        faq5Question: 'วิดีโอที่ Veo 3.1 สร้างมีลายน้ำไหม?',
        faq5Answer:
            'ขึ้นอยู่กับแพ็กเกจสมาชิก 微鲤AI วิดีโอของผู้ใช้ฟรีอาจมีลายน้ำ ส่วนผู้สมัครแบบชำระเงินจะได้วิดีโอคุณภาพสูงแบบไม่มีลายน้ำ',
        faq6Question: 'Veo 3.1 รองรับพรอมต์ภาษาใดบ้าง?',
        faq6Answer:
            'Veo 3.1 รองรับพรอมต์หลายภาษา รวมถึงจีน อังกฤษ ญี่ปุ่น เกาหลี และภาษาอื่น ๆ ที่ใช้งานทั่วไป โมเดล AI สามารถเข้าใจคำอธิบายเชิงสร้างสรรค์ได้อย่างแม่นยำและสร้างคอนเทนต์วิดีโอที่สอดคล้อง',
        faq7Question: 'ฉันสามารถใช้วิดีโอที่ Veo 3.1 สร้างเชิงพาณิชย์ได้ไหม?',
        faq7Answer:
            'สิทธิ์การใช้งานเชิงพาณิชย์ขึ้นอยู่กับข้อตกลงการใช้งานของ 微鲤AI และแพ็กเกจสมาชิกของคุณ แนะนำให้ตรวจสอบเงื่อนไขการใช้งานก่อนนำไปใช้เชิงพาณิชย์ หรือสอบถามฝ่ายบริการลูกค้าเพื่อรายละเอียดใบอนุญาต',

        // CTA section
        ctaTitle: 'เตรียมพร้อมเริ่มสร้างสรรค์แล้วหรือยัง？',
        ctaSubtitle:
            'ลอง Veo 3.1 ตอนนี้และเปลี่ยนไอเดียเป็นวิดีโอสุดตระการตา',
        ctaDescription:
            'สัมผัสพลังของ Veo 3.1 และเปลี่ยนไอเดียสร้างสรรค์ให้เป็นคอนเทนต์วิดีโอระดับมืออาชีพ',
        ctaButton: 'เริ่มสร้างสรรค์',
        ctaNote: 'ไม่ต้องใช้บัตรเครดิต · ทดลองใช้ฟรีสำหรับผู้ใช้ใหม่',

        // Video playback related
        videoNotSupported: 'เบราว์เซอร์ของคุณไม่รองรับการเล่นวิดีโอ',
        videoUnsupported: 'เบราว์เซอร์ของคุณไม่รองรับการเล่นวิดีโอ',
        videoLoadError: 'โหลดวิดีโอล้มเหลว',
        videoReload: 'โหลดใหม่',
        },
    da: {
        // Page title and description
        pageTitle:
            'Google Veo 3.1 | Avanceret AI-videomodel | 微鲤AI',
        pageDescription:
            'Google Veo 3.1 skaber realistiske videoer i høj kvalitet med frame-kontrol, material-to-video, indbygget lyd, sceneudvidelse og præcis promptforståelse. Prøv gratis på 微鲤AI.',
        pageKeywords:
            'Veo 3.1, Google Veo, AI-videogenerator, avanceret videomodel, tekst til video, AI-videoskabelse, 微鲤AI Veo 3.1',

        // Generator section
        generatorTitle: 'Google Veo 3.1 AI-videogenerator',
        generatorDescription:
            'Google Veo 3.1 er den mest avancerede AI-videomodel, som genererer realistisk audio-video i høj kvalitet. Den er en opgraderet version af Veo 3 med markante forbedringer i kvalitet og funktioner. Prøv Veo 3.1 gratis på 微鲤AI-videogeneratoren!',

        // Tabs
        tabImageToVideo: 'Billede til video',
        tabTextToVideo: 'Tekst til video',

        // Core features section
        coreFeaturesTitle: 'Veo 3.1 kernefunktioner',
        coreFeaturesSubtitle:
            'Udforsk kernefunktionerne i Google Veo 3.1 AI-videogenerator og oplev næste generations AI-videoskabelse',

        // Frame to video feature
        frameToVideoTitle: 'Frame-to-Video (første og sidste frame-kontrol)',
        frameToVideoDescription:
            'Veo 3.1 understøtter videogenerering med kontrol af første og sidste frame, så du kan styre start og slut præcist for mere sammenhængende visuel storytelling.',
        frameToFrameTitle: 'Frame-to-Frame-kontrol',
        frameToFrameDescription:
            'Styr videogenereringen ved at angive første og sidste frame, så du får glatte overgange og sammenhængende visuelle fortællinger.',

        // Material to video feature
        materialToVideoTitle: 'Materiale til video',
        materialToVideoDescription:
            'Skab videoer i høj kvalitet baseret på eksisterende materiale og referencer, så du kan genskabe og forbedre indhold visuelt.',

        // Native audio generation feature
        nativeAudioTitle: 'Indbygget lydgenerering',
        nativeAudioDescription:
            'Veo 3.1 skaber lyd og integrerer den i videoerne for perfekt lyd-billedsynk, som gør indholdet mere engagerende og realistisk.',

        // Consistent character feature
        consistentCharacterTitle: 'Konsistent karakterpræstation',
        consistentCharacterDescription:
            'Sørg for at karakterer bevarer et meget ensartet udseende og egenskaber på tværs af scener og shots for en sammenhængende visuel oplevelse.',

        // Advanced prompt feature
        advancedPromptTitle: 'Avanceret promptforståelse',
        advancedPromptDescription:
            'Fortolk komplekse prompts præcist, forstå den kreative intention og omdan tekst til levende visuelle scener.',

        // Scene expansion feature
        sceneExpansionTitle: 'Kraftfuld sceneudvidelse',
        sceneExpansionDescription:
            'Udvid videoscener intelligent for at skabe rigere visuelt indhold og lade kreativiteten bryde tid- og rumbegrænsninger.',

        // How to use section
        howToUseTitle: 'Sådan bruges det',
        howToUseSubtitle: 'Kom i gang med tre enkle trin',
        step1Title: 'Vælg model',
        step1Description: 'Vælg Veo 3.1-modellen i AI-videoværktøjer',
        step2Title: 'Indtast indhold',
        step2Description: 'Indtast tekstprompt eller upload referencebillede',
        step3Title: 'Generér video',
        step3Description: 'Klik på generér, vent og download din video',

        // YouTube videos section
        youtubeVideosTitle:
            'YouTube-videoer om Google Veo 3.1 AI-videomodel',
        youtubeVideoTitle: 'YouTube-videoer om Google Veo 3.1 AI-videomodel',

        // X Posts section
        xPostsTitle: 'X-opslag om Veo 3.1 AI-videomodel',

        // Explore other models section
        exploreOtherModelsTitle: 'Udforsk andre Veo-modeller',
        veo2Title: 'Google Veo 2 AI-videogenerator',
        veo3Title: 'Google Veo 3 AI-videogenerator',
        veo3FastTitle: 'Google Veo 3 Fast AI-videogenerator',

        // FAQ section
        faqTitle: 'Ofte stillede spørgsmål',
        faq1Question: 'Hvad er Google Veo 3.1?',
        faq1Answer:
            'Google Veo 3.1 er den nyeste AI-videomodel fra Google DeepMind og en opgraderet version af Veo 3. Den kan generere realistisk video i høj kvalitet ud fra tekstprompts eller referencebilleder og understøtter avancerede funktioner som frame-to-video, material-to-video og indbygget lydgenerering.',
        faq2Question: 'Hvad er forskellen på Veo 3.1 og Veo 3?',
        faq2Answer:
            'Veo 3.1 er en forbedret version af Veo 3 med stærkere frame-to-video, bedre material-to-video, smartere sceneudvidelse, mere præcis promptforståelse og højere videokvalitet. Veo 3.1 øger både kreativ fleksibilitet og outputkvalitet.',
        faq3Question: 'Hvor lange videoer kan Veo 3.1 generere?',
        faq3Answer:
            'Veo 3.1 kan generere videoer i forskellige længder afhængigt af dine indstillinger og platformens begrænsninger. På 微鲤AI kan du generere videoer fra få sekunder til flere minutter.',
        faq4Question: 'Hvordan bruger jeg Veo 3.1 på 微鲤AI?',
        faq4Answer:
            'Det er meget enkelt: 1) Gå til 微鲤AI og vælg Veo 3.1-modellen; 2) Indtast tekstprompt eller upload referencebillede; 3) Klik generér og vent; 4) Download eller del din video.',
        faq5Question: 'Har Veo 3.1-videoer vandmærker?',
        faq5Answer:
            'Det afhænger af dit 微鲤AI-abonnement. Videoer fra gratis brugere kan have vandmærker, mens betalende brugere kan få videoer uden vandmærker.',
        faq6Question: 'Hvilke sprog understøtter Veo 3.1 for prompts?',
        faq6Answer:
            'Veo 3.1 understøtter prompts på flere sprog, herunder kinesisk, engelsk, japansk, koreansk og andre udbredte sprog. AI-modellen forstår kreative beskrivelser på forskellige sprog og genererer tilsvarende videoindhold.',
        faq7Question: 'Kan jeg bruge Veo 3.1-videoer kommercielt?',
        faq7Answer:
            'Kommercielle brugsrettigheder afhænger af WeryAIs vilkår og dit abonnement. Vi anbefaler at tjekke platformens brugsbetingelser eller kontakte kundeservice for detaljer om licens.',

        // CTA section
        ctaTitle: 'Klar til at begynde at skabe?',
        ctaSubtitle:
            'Prøv Veo 3.1 nu og forvandl dine ideer til fantastiske videoer',
        ctaDescription:
            'Oplev kraften i Veo 3.1 og gør dine kreative ideer til professionelt videoindhold.',
        ctaButton: 'Begynd at skabe',
        ctaNote: 'Intet kreditkort påkrævet · Gratis prøveperiode for nye brugere',

        // Video playback related
        videoNotSupported: 'Din browser understøtter ikke videoafspilning',
        videoUnsupported: 'Din browser understøtter ikke videoafspilning',
        videoLoadError: 'Video kunne ikke indlæses',
        videoReload: 'Genindlæs',
        },
    no: {
        // Page title and description
        pageTitle:
            'Google Veo 3.1 | Avansert AI-videomodell | 微鲤AI',
        pageDescription:
            'Google Veo 3.1 lager realistiske videoer i høy kvalitet med frame-kontroll, material-to-video, innebygd lyd, sceneutvidelse og presis promptforståelse. Prøv gratis på 微鲤AI.',
        pageKeywords:
            'Veo 3.1, Google Veo, AI-videogenerator, avansert videomodell, tekst til video, AI-videoskaping, 微鲤AI Veo 3.1',

        // Generator section
        generatorTitle: 'Google Veo 3.1 AI-videogenerator',
        generatorDescription:
            'Google Veo 3.1 er den mest avanserte AI-videomodellen som genererer realistisk audio-video i høy kvalitet. Den er en oppgradert versjon av Veo 3 med betydelige forbedringer i kvalitet og funksjoner. Prøv Veo 3.1 gratis på 微鲤AI-videogeneratoren!',

        // Tabs
        tabImageToVideo: 'Bilde til video',
        tabTextToVideo: 'Tekst til video',

        // Core features section
        coreFeaturesTitle: 'Veo 3.1 kjernefunksjoner',
        coreFeaturesSubtitle:
            'Utforsk kjernefunksjonene i Google Veo 3.1 AI-videogenerator og opplev neste generasjons AI-videoskaping',

        // Frame to video feature
        frameToVideoTitle: 'Frame-to-Video (kontroll av første og siste frame)',
        frameToVideoDescription:
            'Veo 3.1 støtter videogenerering med kontroll av første og siste frame, slik at du kan styre start og slutt presist for mer sammenhengende visuell historiefortelling.',
        frameToFrameTitle: 'Frame-to-Frame-kontroll',
        frameToFrameDescription:
            'Styr videogenereringen ved å angi første og siste frame, for jevne overganger og sammenhengende visuelle narrativer.',

        // Material to video feature
        materialToVideoTitle: 'Materiale til video',
        materialToVideoDescription:
            'Lag videoer i høy kvalitet basert på eksisterende materiale og referanser, og forbedre innholdet visuelt på en intelligent måte.',

        // Native audio generation feature
        nativeAudioTitle: 'Innebygd lydgenerering',
        nativeAudioDescription:
            'Veo 3.1 lager lyd og integrerer den i videoene for perfekt lyd-bildesynk og mer engasjerende, realistisk innhold.',

        // Consistent character feature
        consistentCharacterTitle: 'Konsistent karakterprestasjon',
        consistentCharacterDescription:
            'Sørg for at karakterer holder et svært konsistent utseende og egenskaper på tvers av scener og shots, for en helhetlig visuell opplevelse.',

        // Advanced prompt feature
        advancedPromptTitle: 'Avansert promptforståelse',
        advancedPromptDescription:
            'Tolk komplekse prompts presist, forstå kreative intensjoner nøyaktig og gjør tekst til levende visuelle scener.',

        // Scene expansion feature
        sceneExpansionTitle: 'Kraftig sceneutvidelse',
        sceneExpansionDescription:
            'Utvid videoscener intelligent for å skape rikere visuelt innhold og la kreativiteten bryte tid- og rombegrensninger.',

        // How to use section
        howToUseTitle: 'Slik bruker du',
        howToUseSubtitle: 'Kom i gang med tre enkle trinn',
        step1Title: 'Velg modell',
        step1Description: 'Velg Veo 3.1-modellen i AI-videoverktøy',
        step2Title: 'Skriv inn innhold',
        step2Description: 'Skriv inn tekstprompt eller last opp referansebilde',
        step3Title: 'Generer video',
        step3Description: 'Klikk generer, vent og last ned videoen din',

        // YouTube videos section
        youtubeVideosTitle:
            'YouTube-videoer om Google Veo 3.1 AI-videomodell',
        youtubeVideoTitle: 'YouTube-videoer om Google Veo 3.1 AI-videomodell',

        // X Posts section
        xPostsTitle: 'X-innlegg om Veo 3.1 AI-videomodell',

        // Explore other models section
        exploreOtherModelsTitle: 'Utforsk andre Veo-modeller',
        veo2Title: 'Google Veo 2 AI-videogenerator',
        veo3Title: 'Google Veo 3 AI-videogenerator',
        veo3FastTitle: 'Google Veo 3 Fast AI-videogenerator',

        // FAQ section
        faqTitle: 'Ofte stilte spørsmål',
        faq1Question: 'Hva er Google Veo 3.1?',
        faq1Answer:
            'Google Veo 3.1 er den nyeste AI-videomodellen fra Google DeepMind og en oppgradert versjon av Veo 3. Den kan generere realistisk video i høy kvalitet basert på tekstprompts eller referansebilder, og støtter avanserte funksjoner som frame-to-video, material-to-video og innebygd lydgenerering.',
        faq2Question: 'Hva er forskjellen mellom Veo 3.1 og Veo 3?',
        faq2Answer:
            'Veo 3.1 er en forbedret versjon av Veo 3 med viktige forbedringer: sterkere frame-to-video, bedre material-to-video, smartere sceneutvidelse, mer presis promptforståelse og høyere videokvalitet. Veo 3.1 øker kreativ fleksibilitet og kvalitet, samtidig som kjernen fra Veo 3 beholdes.',
        faq3Question: 'Hvor lange videoer kan Veo 3.1 generere?',
        faq3Answer:
            'Veo 3.1 støtter videoer i ulike lengder, avhengig av konfigurasjon og plattformbegrensninger. På 微鲤AI kan du generere videoer fra noen sekunder til flere minutter.',
        faq4Question: 'Hvordan bruker jeg Veo 3.1 på 微鲤AI?',
        faq4Answer:
            'Det er enkelt: 1) Gå til 微鲤AI og velg Veo 3.1; 2) Skriv inn tekstprompt eller last opp referansebilde; 3) Klikk generer og vent; 4) Last ned eller del videoen.',
        faq5Question: 'Har Veo 3.1-videoer vannmerker?',
        faq5Answer:
            'Dette avhenger av 微鲤AI-abonnementet ditt. Videoer fra gratis brukere kan ha vannmerker, mens betalende brukere kan få videoer uten vannmerker.',
        faq6Question: 'Hvilke språk støtter Veo 3.1 for prompts?',
        faq6Answer:
            'Veo 3.1 støtter prompts på flere språk, inkludert kinesisk, engelsk, japansk, koreansk og andre vanlige språk. AI-modellen forstår kreative beskrivelser på ulike språk og genererer tilsvarende video.',
        faq7Question: 'Kan jeg bruke Veo 3.1-videoer kommersielt?',
        faq7Answer:
            'Kommersielle bruksrettigheter avhenger av WeryAIs vilkår og abonnementet ditt. Vi anbefaler å lese plattformens bruksavtale eller kontakte kundeservice for lisensdetaljer.',

        // CTA section
        ctaTitle: 'Klar til å begynne å skape?',
        ctaSubtitle:
            'Prøv Veo 3.1 nå og gjør ideene dine om til imponerende videoer',
        ctaDescription:
            'Opplev kraften i Veo 3.1 og gjør kreative ideer om til profesjonelt videoinnhold.',
        ctaButton: 'Begynn å skape',
        ctaNote: 'Ingen kredittkort nødvendig · Gratis prøveperiode for nye brukere',

        // Video playback related
        videoNotSupported: 'Nettleseren din støtter ikke videoavspilling',
        videoUnsupported: 'Nettleseren din støtter ikke videoavspilling',
        videoLoadError: 'Videoen kunne ikke lastes',
        videoReload: 'Last inn på nytt',
        },
    nl: {
        // Page title and description
        pageTitle:
            'Google Veo 3.1 | Geavanceerd AI-videomodel | 微鲤AI',
        pageDescription:
            'Google Veo 3.1 genereert realistische video’s van hoge kwaliteit met framecontrol, material-to-video, native audio, scène-uitbreiding en precieze promptbegrip. Probeer gratis op 微鲤AI.',
        pageKeywords:
            'Veo 3.1, Google Veo, AI-videogenerator, geavanceerd videomodel, tekst naar video, AI-videocreatie, 微鲤AI Veo 3.1',

        // Generator section
        generatorTitle: 'Google Veo 3.1 AI-videogenerator',
        generatorDescription:
            'Google Veo 3.1 is het meest geavanceerde AI-videomodel dat realistische audio-video in hoge kwaliteit kan genereren. Het is een geüpgradede versie van Veo 3 met grote verbeteringen in kwaliteit en functies. Probeer Veo 3.1 gratis op de 微鲤AI-videogenerator!',

        // Tabs
        tabImageToVideo: 'Afbeelding naar video',
        tabTextToVideo: 'Tekst naar video',

        // Core features section
        coreFeaturesTitle: 'Veo 3.1 kernfuncties',
        coreFeaturesSubtitle:
            'Ontdek de kerncapaciteiten van de Google Veo 3.1 AI-videogenerator en ervaar next-gen AI-videocreatie',

        // Frame to video feature
        frameToVideoTitle: 'Frame-to-Video (eerste en laatste frame control)',
        frameToVideoDescription:
            'Veo 3.1 ondersteunt videogeneratie met eerste en laatste frame control, zodat je de start- en eindframes precies kunt sturen voor samenhangende visual storytelling.',
        frameToFrameTitle: 'Frame-to-Frame control',
        frameToFrameDescription:
            'Stuur videogeneratie door het eerste en laatste frame op te geven, voor vloeiende overgangen en samenhangende visuele verhalen.',

        // Material to video feature
        materialToVideoTitle: 'Material to Video',
        materialToVideoDescription:
            'Maak video’s van hoge kwaliteit op basis van bestaande materialen en referenties, voor intelligente recreatie en visuele verbetering van je content.',

        // Native audio generation feature
        nativeAudioTitle: 'Native audiogeneratie',
        nativeAudioDescription:
            'Veo 3.1 maakt audio en integreert dit in de video’s voor perfecte audio-visuele synchronisatie en meer realistische content.',

        // Consistent character feature
        consistentCharacterTitle: 'Consistente karakterperformance',
        consistentCharacterDescription:
            'Zorg dat personages hun uiterlijk en kenmerken consistent houden over verschillende scènes en shots, voor een coherente visuele ervaring.',

        // Advanced prompt feature
        advancedPromptTitle: 'Geavanceerd promptbegrip',
        advancedPromptDescription:
            'Interpreteert complexe prompts nauwkeurig, begrijpt je creatieve intentie en zet tekst om in levendige visuele scènes.',

        // Scene expansion feature
        sceneExpansionTitle: 'Krachtige scène-uitbreiding',
        sceneExpansionDescription:
            'Breid videoscènes intelligent uit om rijkere visuals te maken en je creativiteit door tijd- en ruimtebeperkingen te laten breken.',

        // How to use section
        howToUseTitle: 'Zo gebruik je het',
        howToUseSubtitle: 'Start met drie eenvoudige stappen',
        step1Title: 'Selecteer model',
        step1Description: 'Kies het Veo 3.1-model in de AI-videotools',
        step2Title: 'Voer content in',
        step2Description: 'Voer een tekstprompt in of upload een referentie-afbeelding',
        step3Title: 'Genereer video',
        step3Description: 'Klik op genereren, wacht en download je video',

        // YouTube videos section
        youtubeVideosTitle:
            'YouTube-video\'s over het Google Veo 3.1 AI-videomodel',
        youtubeVideoTitle:
            'YouTube-video\'s over het Google Veo 3.1 AI-videomodel',

        // X Posts section
        xPostsTitle: 'X-berichten over het Veo 3.1 AI-videomodel',

        // Explore other models section
        exploreOtherModelsTitle: 'Ontdek andere Veo-modellen',
        veo2Title: 'Google Veo 2 AI-videogenerator',
        veo3Title: 'Google Veo 3 AI-videogenerator',
        veo3FastTitle: 'Google Veo 3 Fast AI-videogenerator',

        // FAQ section
        faqTitle: 'Veelgestelde vragen',
        faq1Question: 'Wat is Google Veo 3.1?',
        faq1Answer:
            'Google Veo 3.1 is het nieuwste AI-videomodel van Google DeepMind en een upgrade van Veo 3. Het genereert realistische video’s van hoge kwaliteit op basis van tekstprompts of referentiebeelden, met geavanceerde functies zoals frame-to-video, material-to-video en native audiogeneratie.',
        faq2Question: 'Wat is het verschil tussen Veo 3.1 en Veo 3?',
        faq2Answer:
            'Veo 3.1 is een verbeterde versie van Veo 3 met belangrijke upgrades: sterkere frame-to-video, betere material-to-video effecten, slimmere scène-uitbreiding, nauwkeuriger promptbegrip en hogere videokwaliteit. Veo 3.1 verhoogt creatieve flexibiliteit en outputkwaliteit terwijl de kernvoordelen blijven.',
        faq3Question: 'Hoe lang kan Veo 3.1 video’s genereren?',
        faq3Answer:
            'Veo 3.1 ondersteunt video’s van verschillende lengtes, afhankelijk van je configuratie en platformlimieten. Op 微鲤AI kun je video’s genereren van enkele seconden tot meerdere minuten.',
        faq4Question: 'Hoe gebruik ik Veo 3.1 op 微鲤AI?',
        faq4Answer:
            'Het is eenvoudig: 1) Ga naar 微鲤AI en kies Veo 3.1; 2) Voer je tekstprompt in of upload een referentiebeeld; 3) Klik op genereren en wacht; 4) Download of deel je video.',
        faq5Question: 'Bevatten Veo 3.1-video’s watermerken?',
        faq5Answer:
            'Dit hangt af van je 微鲤AI-abonnement. Video’s van gratis gebruikers kunnen watermerken bevatten, terwijl betalende gebruikers video’s zonder watermerk krijgen.',
        faq6Question: 'Welke talen ondersteunt Veo 3.1 voor prompts?',
        faq6Answer:
            'Veo 3.1 ondersteunt prompts in meerdere talen, waaronder Chinees, Engels, Japans, Koreaans en andere gangbare talen. Het AI-model begrijpt creatieve beschrijvingen nauwkeurig en genereert passende video’s.',
        faq7Question: 'Mag ik Veo 3.1-video’s commercieel gebruiken?',
        faq7Answer:
            'Commerciële rechten hangen af van de 微鲤AI-voorwaarden en je abonnement. Controleer de gebruiksvoorwaarden of neem contact op met support voor licentie-informatie.',

        // CTA section
        ctaTitle: 'Klaar om te beginnen met creëren?',
        ctaSubtitle:
            'Probeer Veo 3.1 nu en zet je ideeën om in prachtige video’s',
        ctaDescription:
            'Ervaar de kracht van Veo 3.1 en maak van je creatieve ideeën professioneel videocontent.',
        ctaButton: 'Begin met creëren',
        ctaNote: 'Geen creditcard nodig · Gratis proefperiode voor nieuwe gebruikers',

        // Video playback related
        videoNotSupported: 'Je browser ondersteunt geen video-afspeling',
        videoUnsupported: 'Je browser ondersteunt geen video-afspeling',
        videoLoadError: 'Video laden mislukt',
        videoReload: 'Opnieuw laden',
        },
    id: {
        // Page title and description
        pageTitle:
            'Google Veo 3.1 | Model Generasi Video AI Lanjutan | 微鲤AI',
        pageDescription:
            'Google Veo 3.1 menghasilkan video realistis berkualitas tinggi dengan kontrol frame, material-to-video, audio native, ekspansi scene, dan pemahaman prompt yang presisi. Coba gratis di 微鲤AI.',
        pageKeywords:
            'Veo 3.1, Google Veo, generator video AI, model video lanjutan, teks ke video, pembuatan video AI, 微鲤AI Veo 3.1',

        // Generator section
        generatorTitle: 'Generator Video AI Google Veo 3.1',
        generatorDescription:
            'Google Veo 3.1 adalah model video AI paling canggih yang menghasilkan konten audio-visual berkualitas tinggi dan realistis. Ini adalah versi upgrade dari Veo 3 dengan peningkatan besar pada kualitas dan fitur. Coba Veo 3.1 gratis di generator video 微鲤AI!',

        // Tabs
        tabImageToVideo: 'Gambar ke Video',
        tabTextToVideo: 'Teks ke Video',

        // Core features section
        coreFeaturesTitle: 'Fitur Inti Veo 3.1',
        coreFeaturesSubtitle:
            'Jelajahi kemampuan inti generator video AI Google Veo 3.1 dan rasakan pembuatan video AI generasi berikutnya',

        // Frame to video feature
        frameToVideoTitle: 'Frame-to-Video (Kontrol Frame Pertama & Terakhir)',
        frameToVideoDescription:
            'Veo 3.1 mendukung generasi video melalui kontrol frame pertama dan terakhir, sehingga Anda dapat mengatur awal dan akhir video secara presisi untuk storytelling yang lebih koheren.',
        frameToFrameTitle: 'Kontrol Frame-to-Frame',
        frameToFrameDescription:
            'Kontrol generasi video dengan menentukan frame pertama dan terakhir untuk transisi halus dan narasi visual yang konsisten.',

        // Material to video feature
        materialToVideoTitle: 'Material to Video',
        materialToVideoDescription:
            'Buat video berkualitas tinggi berdasarkan materi dan referensi yang ada, memungkinkan rekreasi cerdas dan peningkatan visual konten Anda.',

        // Native audio generation feature
        nativeAudioTitle: 'Generasi Audio Native',
        nativeAudioDescription:
            'Veo 3.1 menghasilkan audio dan mengintegrasikannya ke video sehingga sinkronisasi audio-visual sempurna untuk konten yang lebih menarik dan realistis.',

        // Consistent character feature
        consistentCharacterTitle: 'Performa Karakter yang Konsisten',
        consistentCharacterDescription:
            'Pastikan karakter tetap konsisten dalam penampilan dan karakteristik di berbagai scene dan shot untuk pengalaman visual yang koheren.',

        // Advanced prompt feature
        advancedPromptTitle: 'Pemahaman Prompt Lanjutan',
        advancedPromptDescription:
            'Menafsirkan prompt kompleks dengan presisi, memahami niat kreatif Anda secara akurat, dan mengubah deskripsi teks menjadi scene visual yang hidup.',

        // Scene expansion feature
        sceneExpansionTitle: 'Ekspansi Scene yang Kuat',
        sceneExpansionDescription:
            'Perluas scene video secara cerdas untuk menghasilkan konten visual yang lebih kaya, sehingga kreativitas Anda melampaui batas waktu dan ruang.',

        // How to use section
        howToUseTitle: 'Cara Menggunakan',
        howToUseSubtitle: 'Mulai berkarya dalam tiga langkah sederhana',
        step1Title: 'Pilih Model',
        step1Description: 'Pilih model Veo 3.1 di alat video AI',
        step2Title: 'Masukkan Konten',
        step2Description: 'Masukkan prompt teks atau unggah gambar referensi',
        step3Title: 'Buat Video',
        step3Description: 'Klik tombol generate, tunggu, lalu unduh video Anda',

        // YouTube videos section
        youtubeVideosTitle:
            'Video YouTube tentang Model Video AI Google Veo 3.1',
        youtubeVideoTitle: 'Video YouTube tentang Model Video AI Google Veo 3.1',

        // X Posts section
        xPostsTitle: 'Posting X tentang Model Video AI Veo 3.1',

        // Explore other models section
        exploreOtherModelsTitle: 'Jelajahi Model Veo Lain',
        veo2Title: 'Generator Video AI Google Veo 2',
        veo3Title: 'Generator Video AI Google Veo 3',
        veo3FastTitle: 'Generator Video AI Google Veo 3 Fast',

        // FAQ section
        faqTitle: 'Pertanyaan yang Sering Diajukan',
        faq1Question: 'Apa itu Google Veo 3.1?',
        faq1Answer:
            'Google Veo 3.1 adalah model generasi video AI terbaru dari Google DeepMind, versi upgrade dari Veo 3. Model ini dapat menghasilkan video realistis berkualitas tinggi dari prompt teks atau gambar referensi, dengan fitur lanjutan seperti frame-to-video, material-to-video, dan generasi audio native.',
        faq2Question: 'Apa perbedaan Veo 3.1 dan Veo 3?',
        faq2Answer:
            'Veo 3.1 adalah versi yang ditingkatkan dari Veo 3 dengan perbaikan utama: kemampuan frame-to-video yang lebih kuat, efek material-to-video yang lebih baik, ekspansi scene yang lebih cerdas, pemahaman prompt yang lebih presisi, dan kualitas video yang lebih tinggi. Veo 3.1 meningkatkan fleksibilitas kreatif dan kualitas output sambil mempertahankan keunggulan inti Veo 3.',
        faq3Question: 'Berapa lama Veo 3.1 dapat membuat video?',
        faq3Answer:
            'Veo 3.1 mendukung pembuatan video dengan berbagai durasi, tergantung konfigurasi dan batasan platform. Di 微鲤AI, Anda dapat membuat video dari beberapa detik hingga beberapa menit.',
        faq4Question: 'Bagaimana cara menggunakan Veo 3.1 di 微鲤AI?',
        faq4Answer:
            'Sangat mudah: 1) Kunjungi 微鲤AI dan pilih model Veo 3.1; 2) Masukkan prompt teks atau unggah gambar referensi; 3) Klik generate dan tunggu; 4) Unduh atau bagikan video Anda.',
        faq5Question: 'Apakah video Veo 3.1 memiliki watermark?',
        faq5Answer:
            'Tergantung paket langganan 微鲤AI Anda. Video dari pengguna gratis mungkin memiliki watermark, sedangkan pelanggan berbayar bisa mendapatkan video berkualitas tinggi tanpa watermark.',
        faq6Question: 'Bahasa apa saja yang didukung Veo 3.1 untuk prompt?',
        faq6Answer:
            'Veo 3.1 mendukung prompt dalam berbagai bahasa, termasuk Mandarin, Inggris, Jepang, Korea, dan bahasa utama lainnya. Model AI dapat memahami deskripsi kreatif dalam berbagai bahasa dan menghasilkan konten video yang sesuai.',
        faq7Question: 'Apakah saya bisa menggunakan video Veo 3.1 secara komersial?',
        faq7Answer:
            'Hak penggunaan komersial tergantung pada ketentuan layanan 微鲤AI dan paket langganan Anda. Kami sarankan memeriksa perjanjian penggunaan platform sebelum penggunaan komersial atau menghubungi layanan pelanggan untuk detail lisensi.',

        // CTA section
        ctaTitle: 'Siap untuk mulai berkarya?',
        ctaSubtitle:
            'Coba Veo 3.1 sekarang dan ubah ide Anda menjadi video yang menakjubkan',
        ctaDescription:
            'Rasakan kekuatan Veo 3.1 dan ubah ide kreatif Anda menjadi konten video profesional.',
        ctaButton: 'Mulai Berkarya',
        ctaNote: 'Tidak perlu kartu kredit · Uji coba gratis untuk pengguna baru',

        // Video playback related
        videoNotSupported: 'Browser Anda tidak mendukung pemutaran video',
        videoUnsupported: 'Browser Anda tidak mendukung pemutaran video',
        videoLoadError: 'Gagal memuat video',
        videoReload: 'Muat ulang',
        },
    tr: {
        // Page title and description
        pageTitle:
            'Google Veo 3.1 | Gelişmiş AI Video Üretim Modeli | 微鲤AI',
        pageDescription:
            'Google Veo 3.1, kare kontrolü, material-to-video, yerleşik ses, sahne genişletme ve hassas prompt anlayışıyla yüksek kaliteli, gerçekçi videolar üretir. 微鲤AI’de ücretsiz deneyin.',
        pageKeywords:
            'Veo 3.1, Google Veo, AI video üretici, gelişmiş video modeli, metinden videoya, AI video oluşturma, 微鲤AI Veo 3.1',

        // Generator section
        generatorTitle: 'Google Veo 3.1 AI Video Üretici',
        generatorDescription:
            'Google Veo 3.1, yüksek kaliteli ve gerçekçi sesli-görsel içerik üreten en gelişmiş AI video modelidir. Veo 3’ün geliştirilmiş sürümüdür ve kalite ile özelliklerde önemli iyileştirmeler sunar. Veo 3.1’i 微鲤AI video üreticide ücretsiz deneyin!',

        // Tabs
        tabImageToVideo: 'Görselden Videoya',
        tabTextToVideo: 'Metinden Videoya',

        // Core features section
        coreFeaturesTitle: 'Veo 3.1 Temel Özellikler',
        coreFeaturesSubtitle:
            'Google Veo 3.1 AI video üreticisinin temel yeteneklerini keşfedin ve yeni nesil AI video üretimini deneyimleyin',

        // Frame to video feature
        frameToVideoTitle: 'Frame-to-Video (İlk ve Son Kare Kontrolü)',
        frameToVideoDescription:
            'Veo 3.1, ilk ve son kare kontrolüyle video üretimini destekler; böylece videonun başlangıç ve bitiş karelerini hassas biçimde kontrol ederek daha tutarlı bir görsel anlatı elde edersiniz.',
        frameToFrameTitle: 'Frame-to-Frame Kontrolü',
        frameToFrameDescription:
            'İlk ve son kareyi belirleyerek video üretimini kontrol edin; akıcı geçişler ve tutarlı görsel anlatılar oluşturun.',

        // Material to video feature
        materialToVideoTitle: 'Material to Video',
        materialToVideoDescription:
            'Mevcut materyal ve referanslara dayalı yüksek kaliteli videolar oluşturun; içeriklerinizi akıllıca yeniden üretip görsel olarak güçlendirin.',

        // Native audio generation feature
        nativeAudioTitle: 'Yerleşik Ses Üretimi',
        nativeAudioDescription:
            'Veo 3.1 sesi üretir ve videolara entegre eder; böylece mükemmel ses-görüntü senkronu ile daha gerçekçi ve etkileyici içerikler sağlar.',

        // Consistent character feature
        consistentCharacterTitle: 'Tutarlı Karakter Performansı',
        consistentCharacterDescription:
            'Karakterlerin farklı sahne ve çekimlerde görünüm ve özelliklerini yüksek tutarlılıkla korumasını sağlayarak bütünlüklü bir görsel deneyim oluşturun.',

        // Advanced prompt feature
        advancedPromptTitle: 'Gelişmiş Prompt Anlayışı',
        advancedPromptDescription:
            'Karmaşık promptları hassas biçimde yorumlar, yaratıcı niyetinizi doğru anlar ve metin açıklamalarını canlı görsel sahnelere dönüştürür.',

        // Scene expansion feature
        sceneExpansionTitle: 'Güçlü Sahne Genişletme',
        sceneExpansionDescription:
            'Videolu sahneleri akıllıca genişleterek daha zengin görsel içerikler üretin ve yaratıcılığınızın zaman-mekan sınırlarını aşmasını sağlayın.',

        // How to use section
        howToUseTitle: 'Nasıl Kullanılır',
        howToUseSubtitle: 'Üç basit adımda başlayın',
        step1Title: 'Model Seçin',
        step1Description: 'AI video araçlarında Veo 3.1 modelini seçin',
        step2Title: 'İçerik Girin',
        step2Description: 'Metin promptu girin veya referans görsel yükleyin',
        step3Title: 'Video Üretin',
        step3Description: 'Oluştur düğmesine tıklayın, bekleyin ve videonuzu indirin',

        // YouTube videos section
        youtubeVideosTitle:
            'Google Veo 3.1 AI Video Modeli Hakkında YouTube Videoları',
        youtubeVideoTitle:
            'Google Veo 3.1 AI Video Modeli Hakkında YouTube Videoları',

        // X Posts section
        xPostsTitle: 'Veo 3.1 AI Video Modeli Hakkında X Paylaşımları',

        // Explore other models section
        exploreOtherModelsTitle: 'Diğer Veo Modellerini Keşfedin',
        veo2Title: 'Google Veo 2 AI Video Üretici',
        veo3Title: 'Google Veo 3 AI Video Üretici',
        veo3FastTitle: 'Google Veo 3 Fast AI Video Üretici',

        // FAQ section
        faqTitle: 'Sıkça Sorulan Sorular',
        faq1Question: 'Google Veo 3.1 nedir?',
        faq1Answer:
            'Google Veo 3.1, Google DeepMind tarafından geliştirilen en yeni AI video üretim modelidir ve Veo 3’ün yükseltilmiş sürümüdür. Metin promptları veya referans görsellere dayalı yüksek kaliteli, gerçekçi video içerikleri üretir ve frame-to-video, material-to-video ve yerleşik ses üretimi gibi ileri özellikleri destekler.',
        faq2Question: 'Veo 3.1 ile Veo 3 arasındaki fark nedir?',
        faq2Answer:
            'Veo 3.1, Veo 3’ün geliştirilmiş bir sürümüdür ve temel iyileştirmeler sunar: daha güçlü frame-to-video, daha iyi material-to-video etkileri, daha akıllı sahne genişletme, daha hassas prompt anlayışı ve daha yüksek video kalitesi. Veo 3.1, Veo 3’ün temel avantajlarını korurken yaratıcı esnekliği ve çıktı kalitesini artırır.',
        faq3Question: 'Veo 3.1 videoları ne kadar uzun olabilir?',
        faq3Answer:
            'Veo 3.1, seçtiğiniz yapılandırma ve platform sınırlamalarına bağlı olarak farklı uzunluklarda video üretimini destekler. 微鲤AI üzerinde birkaç saniyeden birkaç dakikaya kadar video üretebilirsiniz.',
        faq4Question: 'Veo 3.1’i 微鲤AI’de nasıl kullanırım?',
        faq4Answer:
            'Çok basit: 1) 微鲤AI platformuna gidin ve Veo 3.1 modelini seçin; 2) Metin promptunuzu girin veya referans görsel yükleyin; 3) Oluştur düğmesine tıklayın ve bekleyin; 4) Videonuzu indirin veya paylaşın.',
        faq5Question: 'Veo 3.1 videolarında filigran var mı?',
        faq5Answer:
            'Bu, 微鲤AI abonelik planınıza bağlıdır. Ücretsiz kullanıcıların videolarında filigran olabilir; ücretli aboneler ise filigransız yüksek kaliteli videolar alabilir.',
        faq6Question: 'Veo 3.1 promptlar için hangi dilleri destekliyor?',
        faq6Answer:
            'Veo 3.1, Çince, İngilizce, Japonca, Korece ve diğer yaygın diller dahil birçok dili destekler. AI modeli, farklı dillerdeki yaratıcı açıklamaları doğru anlayabilir ve karşılık gelen videoları üretebilir.',
        faq7Question: 'Veo 3.1 videolarını ticari olarak kullanabilir miyim?',
        faq7Answer:
            'Ticari kullanım hakları, 微鲤AI kullanım koşulları ve abonelik planınıza bağlıdır. Ticari kullanım öncesinde platformun kullanım sözleşmesini kontrol etmenizi veya lisans bilgileri için müşteri hizmetleriyle iletişime geçmenizi öneririz.',

        // CTA section
        ctaTitle: 'Hazır mısınız?',
        ctaSubtitle:
            'Veo 3.1’i şimdi deneyin ve fikirlerinizi etkileyici videolara dönüştürün',
        ctaDescription:
            'Veo 3.1’in gücünü deneyin ve yaratıcı fikirlerinizi profesyonel video içeriğine dönüştürün.',
        ctaButton: 'Oluşturmaya Başla',
        ctaNote: 'Kredi kartı gerekmez · Yeni kullanıcılar için ücretsiz deneme',

        // Video playback related
        videoNotSupported: 'Tarayıcınız video oynatmayı desteklemiyor',
        videoUnsupported: 'Tarayıcınız video oynatmayı desteklemiyor',
        videoLoadError: 'Video yüklenemedi',
        videoReload: 'Yeniden yükle',
    },
}
